import DateFnsUtils from "@date-io/date-fns";
import { CircularProgress, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Auth } from "aws-amplify";
import axios from "axios";
import html2canvas from "html2canvas";
import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import configuration from "../../../configurations";
import i18n from "../../../i18next";
import CommonTable from "../../CommonScreens/commonTable";
import Sample from "../../CommonScreens/sampleTextField";
import Loader from "../../loader";
import SignScroll from "./SignScroll";
import customeClasses from "./SubmitApplication.css";
import TextSignature from "./TextSignature";
import accessIcon from '../../../Assets/Images/access.png';
import failIcon from '../../../Assets/Images/fail.png';
import pendingIcon from '../../../Assets/Images/pending.svg';
import { isMobile } from "react-device-detect";
import Receipt from "./Receipt";
import InfoIcon from '@material-ui/icons/Info';
import ChangePayment from '../Enrollment/ChangePayment/ChangePayment';
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close';
import Suggestions from "../../CommonScreens/Suggestions.js";
import { valid } from "semver";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { getDateTime } from "../../authentication/utils.js";

const cookies = new Cookies();
var convert = require("xml-js");

const styles = (props) => ({
  colorPrimary: {
    backgroundColor: "#f2f2f2",
    width: "100%",
    marginTop: "24px",
    height: "10px",
    marginBottom: "34px",
  },
  barColorPrimary: {
    backgroundColor: "#003e7d",
  },
});

const ViewButton = withStyles(customStyle.viewBtn)(Button);

const CssTextField = withStyles(() => ({
  root: {
    "& .MuiInput-root": {
      "&:hover:not($disabled):not($focused):not($error):before": {
        borderBottom: "2px solid #23436c",
      },

      "&.MuiInput-underline.Mui-focused:after": {
        borderBottom: "2px solid #23436c",
      },
    },
  },
}))(TextField);

// const WizardButton = withStyles(customStyle.viewBtn)(Button);

// const FinishButton = withStyles(customStyle.proceedBtn)(Button);

// const CustomeButton = withStyles(customStyle.viewBtn)(Button);

// const NextButton = withStyles(customStyle.NextButton)(Button);

const WizardButton = withStyles(customStyle.viewNetwellBtn)(Button);

const FinishButton = withStyles(customStyle.proceedNetwellBtn)(Button);

const CustomeButton = withStyles(customStyle.viewNetwellBtn)(Button);
const ViewQuoteButton = withStyles(customStyle.viewQuotesBtn)(Button);
const NextButton = withStyles(customStyle.NextButtonNetwell)(Button);

const PurpleRadio = withStyles(customStyle.radioBtn)((props) => (
  <Radio color="default" {...props} />
));

const JoinderAgreement = process.env.REACT_APP_JOINDERAGREEMENT;
const Terms = process.env.REACT_APP_TERMS;
const AllstateTerms = process.env.REACT_APP_ALLSTATETERMS;
const Finalwrap =``;

var reenrollmentFlag = false;

class SubmitApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 1,
      progress: 0,
      loaderShow: false,
      authorization: false,
      healthTerms: false,
      fullName: "",
      submitDone: false,
      modalShow: false,
      successModal: false,
      popUpMsg: "",
      modalShowPrivacy: false,
      modalShow4Privacy: false,
      authModalShow: false,
      authModalShow4: false,
      privacyPolicy: false,
      privacyPolicy4: false,
      authorize: false,
      authorize4: false,
      authorize1: false,
      nextDisabled: true,
      finaceAuth: false,
      financeAuthModalShow: false,
      authModalShow1: false,
      authorize44: false,
      paymentScreenModal: false,
      planFamilyDetails: [],
      programName: "",
      otherQuote: [],
      todayPayment: [],
      text: "",
      recurringPayment: [],
      totalCost: "",
      headerData: [],
      tooltipData: [],
      plansList: [],
      totalPayment: {},
      planSelectionModal: false,
      enrollFlag: false,
      phoneNumber: "",
      contactModal: false,
      countryCode: "+1",
      targetDate: null,
      targetDateModal: false,
      dateErr: false,
      birthDtFocus: false,
      birthDt: false,
      agentName: "",
      emailPhoneModal: false,
      email: "",
      isvalidEmailPhone: true,
      validationError: false,
      reqType: "",
      tableData: null,
      popTable: null,
      FamilyDetailsMoreInfoModal: false,
      fromMember: false,
      emailModal: false,
      fromLogin: false,
      enroll: false,
      showCommonErrorModal: false,
      inviteStatusModal: false,
      inviteStatusFlag: false,
      inviteStatus: "",
      draftDayModal: false,
      draftDaySelected: "",
      memberPlanInfo: "",
      effectivePaymentDate: "",
      firstPaymentDate: "",
      firstPaymentAmount: "",
      todayDate: "",
      initialApplicationFee: "",
      subsequentPaymentDate: "",
      creditCard: false,
      openSignScroll: false,
      clearSign: false,
      signType: "stylized",

      payflag: null,

      canvasChanged: false,
      canvasDone: false,
      imgUrl: "",
      signScrollImage: null,
      isValidFullName: true,
      submitText: null,
      checkBox5: false,

      ModalShow6: false,
      checkBox6: false,
      disQualifiedData: null,
      ModalShow7: false,
      ModalShowPDF:false,
      checkBox7: false,
      showCheckBox6: true,
      ModalShow8: false,
      checkBox8: false,
      checkBoxFirst: false,
      checkBoxAllstate: false,
      checkBoxSecond: false,
      checkBoxThird: false,
      checkBoxFourth: false,
      checkBoxFifth: false,
      isSaved: false,
      minDate: null,
      subID: JSON.parse(localStorage.getItem('CurrentLoginUser')).id,
      isEnrolled: false,
      showOnlyAllstateCheckbox: false,
      programInfo:null,
      ProgramSummary:false,
      viewProgramSummary: false,
      checkBoxSixProgramSummary:false,
      htmlMedicalInfo:null,
      statusModal: false,
      termsAndConditionLink: null,
      resendAuthModal:false,
      emailFlag: false,
      sourceid: null,
      addressModal: false,
      receiptDetails: null,
      submitWaitModal: null,
      isBillAddrDiff: false,
      isBillAddrValid: true,
      userBillingAddress: {
        street: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        addrs:""
      },
      userAddress: {
        postalCode: "",
        street: "",
        city: "",
        state: "",
        country: "",
        addrs:""
      },
      submitWaitModal: null,
      showPaymentModal: false,
      alertMessage: '',
      alertValue: '',
      imageSource: '',
      suggestions: {},
      isMailingStreet: true,
      isMailStreetSelected: false,
      isBillStreetSelected: false,
      showPlaid: false,
      achSelected: false,
      isACHSuccess: false,
      plaidLink: "",
    };

    this.child = React.createRef();
    this.iframeRef = React.createRef();
  }

  toggleAlertBox = (message, showAlert, payType) => {
    if (payType === "ACH") this.setState({ achSelected: true })
    // props.toggleAlertBox(response.data.message, true, 'Alert')
    this.setState({alertMessage: message})
    this.toggleAlert(message, showAlert);
}
toggleAlert = (message, value) => {
    this.setState({alertValue: false});
    setTimeout(() => {
        this.setState({alertValue: value});
    }, 10);
    if(value == "close") {
      this.setState({showPaymentModal: false, paymentScreenModal: true, fromACHFail: true})
    }
}
  /*------------------Finance Auth Modal------------------------*/
  showFinanceAuthModal = (event) => {
    this.setState(
      {
        financeAuthModalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalFinaceAuth = (event) => {
    this.setState(
      {
        financeAuthModalShow: false,
        authorization: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  showCheckbox5 = (event) => {
    this.setState(
      {
        checkBox5: !this.state.checkBox5,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideCheckbox5 = (event) => {
    this.setState(
      {
        financeAuthModalShow: false,
        checkBox5: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  showModal7pdf = (event) => {
    this.setState(
      {
        ModalShowPDF: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  showModal7ProgramInfo = (event) => {
    this.setState(
      {
        ProgramSummary: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  showModal8ProgramInfo = (event) => {
    this.setState(
      {
        ModalShowPDF: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  showModal6 = (event) => {
    this.setState(
      {
        ModalShow6: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  hideModal7PDF = (event) => {
    this.setState(
      {
        ModalShowPDF: false,
        checkBoxFifth: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  hideModal8ProgramSummary = (event) => {
    this.setState(
      {
        ProgramSummary: false,
        checkBoxSixProgramSummary: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  hideModal6 = (event) => {
    this.setState(
      {
        ModalShow6: false,
        checkBox6: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  acceptModal6 = () => {
    this.setState(
      {
        ModalShow6: false,
        checkBox6: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  acceptModal7PDF = () => {
    this.setState(
      {
        ModalShowPDF: false,
        checkBoxFifth: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  acceptModal8ProgramSummary = () => {
    this.setState(
      {
        ProgramSummary:false,
        checkBoxSixProgramSummary:true
      },
      () => {
        this.getDisabled();
      }
    );
  };
  showModal7 = (event) => {
    this.setState(
      {
        ModalShow7: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModal7 = (event) => {
    this.setState(
      {
        ModalShow7: false,
        checkBox7: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  acceptModal7 = () => {
    this.setState(
      {
        ModalShow7: false,
        checkBox7: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  showModal8 = (event) => {
    this.setState(
      {
        ModalShow8: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModal8 = (event) => {
    this.setState(
      {
        ModalShow8: false,
        checkBox8: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  acceptModal8 = () => {
    this.setState(
      {
        ModalShow8: false,
        checkBox8: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalFinaceAuth11 = (event) => {
    if (this.state.authorization == false) {
      this.setState(
        {
          financeAuthModalShow: false,
          authorization: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          financeAuthModalShow: false,
          authorization: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  acceptFinaceAuth = () => {
    this.setState(
      {
        financeAuthModalShow: false,
        authorization: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  /*================================ privacy policy modal ===============================*/
  hideModalPrivacy = (event) => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalPrivacy11 = (event) => {
    if (this.state.privacyPolicy == true) {
      this.setState(
        {
          modalShowPrivacy: false,
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShowPrivacy: false,
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  /*---------------------  privacy 4--------- */
  hideModal4Privacy = (event) => {
    this.setState(
      {
        authModalShow4: false,
        authorize44: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModal4Privacy11 = (event) => {
    if (this.state.privacyPolicy4 == false) {
      this.setState(
        {
          authModalShow4: false,
          privacyPolicy4: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow4: false,
          privacyPolicy4: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showModalPopup = (event) => {
    if (event.target.checked) {
      this.setState(
        {
          modalShow: false,
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShow: false,
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  viewPlanHideModal = (event) => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: false,
        loaderShow: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  getWaitingPeriodSummary = () => {
    let subId = JSON.parse(localStorage.getItem("CurrentLoginUser")).id;
    axios
      .get(
        configuration.baseUrl + `/questionbank/getEnrollMemberSummary/${subId}`
      )
      .then((response) => {
        if (response.data.response && Object.keys(response.data.response).length !== 0) {
          var data = [];
          Object.keys(response.data.response).map((key, index) => {
          if(key!=="knockoutMember" && response.data.response[key].filter(result => result.limitation=="4").length>0){
              data.push({
                "family member": [
                  <span style={{ fontWeight: "500" }}>{key}</span>,
                ],
                reason: [
                  response.data.response[key].filter(result => result.limitation=="4").map((res, i) => (
                    <span style={{ fontWeight: "500" }}>
                      {res.disease}
                      {response.data.response[key].filter(result => result.limitation=="4").length === i + 1
                        ? "."
                        : ","}{" "}
                    </span>
                  )),
                ],
                "Eligibility Details": [
                  <div>
                          <span style={{ fontWeight: "500", fontSize: "15px" }}>
                            Initial waiting period of {response.data.response[key].filter(result => result.limitation=="4")[0].limitation}-years
                          </span>
                  </div>,
                ],
              });
            }

            if(key!=="knockoutMember" && response.data.response[key].filter(result => result.limitation=="2").length>0){
              data.push({
                "family member": [
                  <span style={{ fontWeight: "500" }}>{key}</span>,
                ],
                reason: [
                  response.data.response[key].filter(result => result.limitation=="2").map((res, i) => (
                    <span style={{ fontWeight: "500" }}>
                      {res.disease}
                      {response.data.response[key].filter(result => result.limitation=="2").length === i + 1
                        ? "."
                        : ","}{" "}
                    </span>
                  )),
                ],
                "Eligibility Details": [
                  <div>
                          <span style={{ fontWeight: "500", fontSize: "15px" }}>
                            Initial waiting period of {response.data.response[key].filter(result => result.limitation=="2")[0].limitation}-years
                          </span>
                  </div>,
                ],
              });
            }

            if(key!=="knockoutMember" && response.data.response[key].filter(result => result.limitation=="Lifetime").length>0){
              data.push({
                "family member": [
                  <span style={{ fontWeight: "500" }}>{key}</span>,
                ],
                reason: [
                  response.data.response[key].filter(result => result.limitation=="Lifetime").map((res, i) => (
                    <span style={{ fontWeight: "500" }}>
                      {res.disease}
                      {response.data.response[key].filter(result => result.limitation=="Lifetime").length === i + 1
                        ? "."
                        : ","}{" "}
                    </span>
                  )),
                ],
                "Eligibility Details": [
                  <div>
                          <span style={{ fontWeight: "500", fontSize: "15px" }}>
                          Lifetime Limitation
                          </span>
                  </div>,
                ],
              });
            }

          });

          this.setState({
            disQualifiedData: {
              header: [
                "Family Member",
                "Health Condition",
                "Limitation Details",
              ],
              data: data.reverse(),
              instruction: [
                //  <span style={{fontWeight:"bold"}}>"Here is a summary of the eligibility check [TBD]."</span>,
                <br></br>,
                [
                  "The family members listed alongside are either not eligible for enrollment into the netWell Program or have an initial waiting period. You can choose to exclude members and continue enrolling other members of your family for this program.",
                ],
              ],
              flag: false,
              questionFlag: true,
            },
          });
        } else {
          this.setState({ checkBox6: true, showCheckBox6: false });
        }
      })
      .catch((error) => {});
  };
  checkPrivacy = (event) => {
    if (event.target.checked) {
      this.setState(
        {
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showPlansModalPrivacy = () => {
    if (this.state.privacyPolicy == true) {
      this.setState({ privacyPolicy: true, modalShowPrivacy: true });
    } else {
      this.setState(
        {
          modalShowPrivacy: true,
          privacyPolicy: false,
          // loaderShow : true
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  acceptPrivacyPolicy = () => {
    this.setState(
      {
        // modalShowPrivacy: false,
        privacyPolicy: !this.state.privacyPolicy,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptPrivacyPolicy4 = () => {
    this.setState(
      {
        authModalShow4: false,
        authorize44: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  /*================================ privacy policy modal ===============================*/

  /*============================authoroise modal ====================================*/
  authorizeHideModal = (event) => {
    this.setState(
      {
        authModalShow: false,
        authorize: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  authorizeHideModal22 = (event) => {
    if (this.state.authorize == false) {
      this.setState(
        {
          authModalShow: false,
          authorize: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow: false,
          authorize: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  authorizeHideModal1 = (event) => {
    this.setState(
      {
        authModalShow1: false,
        authorize1: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  authorizeHideModal111 = (event) => {
    if (this.state.authorize1 == false) {
      this.setState(
        {
          authModalShow1: false,
          authorize1: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow1: false,
          authorize1: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showAuthorizeModalPopup = (event) => {
    this.setState(
      {
        authModalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  toggleSignScrollModal = (mode) => {
    this.setState({
      openSignScroll: mode,
    });
  };

  changeSignType = (e, v) => {
    this.setState({
      signType: v,
      fullName: v === "stylized" ? "" : this.state.fullName,
    });
  };

  handleSignClear = () => {
    this.child.current.clearCanvas();
  };

  dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(",")[1]);

    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  handleSignDone = () => {
    this.child.current.cropImageFromCanvas();
    this.child.current.disableCanvas();

    this.setState({
      canvasDone: true,
      canvasChanged: false,
    });
    this.nameChangeHandler(this.state.fullName, this.state.fullName !== "");
    const img = this.child.current.convertCanvasToImage();

    this.setState({
      isValidFullName: this.state.fullName === "" ? false : true,
    });
    this.setState({imageSource: img.src})
    return img.src;
  };

  showAuthorizeModalPopup4 = (event) => {
    this.setState(
      {
        authModalShow4: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  showAuthorizeModalPopup2 = (event) => {
    this.setState(
      {
        authModalShow1: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  checkFellowshipStatus = () => {
    this.setState(
      {
        authorize: !this.state.authorize,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptAuthorization = () => {
    this.setState(
      {
        authModalShow: false,
        authorize: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptAuthorization1 = () => {
    this.setState(
      {
        authorize1: !this.state.authorize1,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  /*============================authoroise modal ====================================*/

  showPlansModal1 = (event) => {
    this.setState({
      modalShow: true,
    });
  };

  reduceProgress = () => {
    console.log(this.state.count);
    if (this.state.count == 1) {
      this.props.handlePrev();
    }else if (this.state.count > 1) {
      this.setState(
        {
          // count: this.state.count - 1,
          count: 1,

          // progress: ((this.state.count - 1) / 4) * 100,
          progress: 0,

          canvasChanged: false,
          canvasDone: false,
          fullName: "",
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  increaseProgress = (e) => {
    this.setState({
      loaderShow: true,
    });
    if (e.detail === 1){
    let obj = new Object();
    obj.subId = this.state.subID;
    if (this.state.count === 1) {
      obj.policy = true;
      obj.ipAddress = sessionStorage.getItem("PUBLIC-IP");
    } else if (this.state.count === 2) {
      obj.financialPolicy = true;
    } else if (this.state.count === 3) {
      obj.sharePolicy = true;
      obj.enrollFlag = true;
    }

    axios
      .post(configuration.baseUrl + "/enrollment/saveAuthorization", obj)
      .then((response) => {
        if (response.data.code === 200) {
          if (this.state.count < 4) {
            this.setState(
              {
                // count: this.state.count + 1,
                count: 4,

                // progress: ((this.state.count + 2) / 4) * 100,
                progress: (4 / 4) * 100,

                loaderShow: false,
              },
              () => {
                this.getDisabled();
              }
            );
          } else {
            this.setState(
              {
                // count: this.state.count + 1,
                count: 4,

                // progress: ((this.state.count + 2) / 4) * 100,
                progress: (4 / 4) * 100,

                loaderShow: false,
              },
              () => {
                this.getDisabled();
              }
            );
          }
        }
      });
    }
  };

  nameChangeHandler = (val, isValid, parentObj) => {
    if (isValid) {
      this.setState({
        fullName: val,
        isValidFullName: true,
      });
    } else {
      this.setState({
        fullName: "",
        isValidFullName: false,
      });
    }
  };


  //--- Draft Day ------>
  handleUpdateEffectdate = (e) =>{
    let obj = {
        "subId": this.state.subID,
        "effectiveDate":moment(this.state.targetDate).format("YYYY-MM-DD"),
        "draftDate":moment().format("YYYY-MM-DD"),
        "paymentDay":"Today"
    }
    this.setState({
      submitWaitModal: true
    })
    if(e.detail === 1)
    axios.post(process.env.REACT_APP_BASE_URL+"/plan/updateMemberPlan", obj).then((resp)=>{
      this.setState({
        targetDateModal: false
      })
      this.saveApplication();
    })
   
}

  openDraftDayModal = () => {
    this.setState({
      loaderShow: true,
      addressModal: false,
      targetDateModal: false
      // draftDayModal: true,
    });

    fetch(
      configuration.baseUrl +
        "/setuppayment/getPaymentDetails/" +
        this.state.subID
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response) {
          var totalAmount = response.response.amount;

          if (response.response.paymentType === "CC") {
            var calApplicatioFee = 1 + 1 * 0.035;
            calApplicatioFee = calApplicatioFee.toFixed(2);
            this.setState({
              initialApplicationFee: '$' + this.state.myAppFee,
              firstPaymentAmount: (totalAmount - calApplicatioFee).toFixed(2),
              creditCard: true,
            });
          } else {
            this.setState({
              initialApplicationFee: '$' + this.state.myAppFee,
              firstPaymentAmount: (totalAmount - 0).toFixed(2),
              creditCard: false,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    var tDate = new Date();

    fetch(configuration.baseUrl + "/plan/getMemberPlan/" + this.state.subID+ '/Core')
      .then((selectedPlan) => selectedPlan.json())
      .then((selectedPlan) => {
        if (selectedPlan.response) {
          console.log('plan', selectedPlan.response);
          this.setState({
            loaderShow: false,
            memberPlanInfo: selectedPlan.response,
            //firstPaymentAmount: getFirstPaymentAmount,
            todayDate: moment(tDate).format("dddd, MMMM Do, YYYY"),
          });

          console.log("==selectedPlan==", selectedPlan.response);

          let data = {
            subId: this.state.memberPlanInfo.subId,
            planId: this.state.memberPlanInfo.planId,
            planCode: this.state.memberPlanInfo.planCode,
            amount: this.state.memberPlanInfo.amount,
            targetDate: moment(this.state.targetDate).format("YYYY-MM-DD"),
            acsm: this.state.memberPlanInfo.acsm,
            draftDay: this.state.memberPlanInfo.draftDay,
            appFeeWaiver:JSON.parse(localStorage.getItem("appFeeWaiver"))
          };
    
          axios
          .post(configuration.baseUrl + "/plan/saveMemberPlan", data)
          .then((response) => {
            this.setState({
              loaderShow: false,
              draftDayModal: false,
              targetDateModal: false,
            });
            this.saveApplication();
          })
          .catch((error) => {
            console.log(error);
            this.setState({
              successModal: true,
              popUpMsg: "Internal Server Error",
              loaderShow: false,
            });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  answerChangeHandler = (event, name, optionId) => {
    if (name === "radio") {
      var paymentDate = moment(this.state.targetDate)
        .subtract(event.target.value, "days")
        .format("MM/DD/YYYY");
      var getSubsequentPaymentDate = moment(this.state.targetDate)
        .subtract(event.target.value, "days")
        .format("MM/DD/YYYY");

      var varDate = new Date(paymentDate);
      var today = new Date();

      if (varDate >= today) {
        console.log("future date");
      } else {
        console.log("past date");
        paymentDate = today;
      }
      this.setState({
        draftDaySelected: event.target.value,
        effectivePaymentDate: moment(this.state.targetDate).format(
          "dddd, MMMM Do, YYYY"
        ),
        firstPaymentDate: moment(paymentDate).format("dddd, MMMM Do, YYYY"),
        subsequentPaymentDate: getSubsequentPaymentDate,
      });
    }
  };

  handleDraftModalClose = () => {
    this.setState({
      draftDayModal: false,
      draftDaySelected: "",
    });
  };

  submitDraftDay = () => {
    let data = {
      subId: this.state.memberPlanInfo.subId,
      planId: this.state.memberPlanInfo.planId,
      planCode: this.state.memberPlanInfo.planCode,
      amount: this.state.memberPlanInfo.amount,
      targetDate: moment(this.state.targetDate).format("YYYY-MM-DD"),
      acsm: this.state.memberPlanInfo.acsm,
      draftDay: parseInt(this.state.draftDaySelected),
      appFeeWaiver:JSON.parse(localStorage.getItem("appFeeWaiver"))
    };

    console.log("====saveMemberPlan===", data);

    axios
      .post(configuration.baseUrl + "/plan/saveMemberPlan", data)
      .then((response) => {
        this.setState({
          loaderShow: false,
          draftDayModal: false,
          targetDateModal: false,
        });
        this.saveApplication();
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          successModal: true,
          popUpMsg: "Internal Server Error",
          loaderShow: false,
        });
      });
  };

  saveTargetDate = () => {
    //-- Not using this call as we are showing draft day [Safal 29 Oct]
    this.setState({ targetDateModal: false, loaderShow: true });

    let date = moment(this.state.targetDate).format("YYYY-MM-DD");
    let obj = {
      subId: this.state.subID,
      targetDate: date,
    };
    axios
      .post(configuration.baseUrl + "/plan/updateBenefitBeginDate", obj)
      .then((res) => {
        console.log("============ res ===============");
        console.log(res);
        if (res.data.code === 200) {
          this.saveApplication();
        } else {
          this.setState({
            successModal: true,
            popUpMsg: "Internal Server Error",
            loaderShow: false,
          });
        }
      });
  };

  uploadImage = async (file) => {
    let formData = new FormData();
    formData.append(
      "file",
      file,
      `${
        JSON.parse(localStorage.getItem("CurrentLoginUser")).id
      }-${new Date().getTime()}.png`
    );

    await axios
      .post(configuration.baseUrl + "/enrollment/uploadImage", formData)
      .then((res) => {
        this.setState({
          // loaderShow: false,
          imgUrl: res.data.response,
        });
        return res.data.response;
      });
  };

  textSignatureToImage = () => {
    const inner =
      document.getElementById("signInnerText") ||
      document.getElementById("signTextContent") ||
      document.getElementById("TextSignContainer");
    const container = document.getElementById("TextSignContainer") || inner;

    if (!inner) {
      const optionsFallback = {
        backgroundColor: window.getComputedStyle(container).backgroundColor || null,
        useCORS: true,
        scale: window.devicePixelRatio || 1,
      };
      return html2canvas(container, optionsFallback).then(function (canvas) {
        return canvas.toDataURL("image/png");
      });
    }

    const leftPad = 20;
    const rightPad = 12;
    const verticalPad = 12;
    const rect = inner.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const sx = Math.max(0, Math.floor(rect.left - containerRect.left - leftPad));
    const sy = Math.max(0, Math.floor(rect.top - containerRect.top - verticalPad));
    const sw = Math.ceil(rect.width + leftPad + rightPad);
    const sh = Math.ceil(rect.height + verticalPad * 2);

    const scale = window.devicePixelRatio || 1;

    const options = {
      backgroundColor: window.getComputedStyle(container).backgroundColor || null,
      useCORS: true,
      scale,
    };

    return html2canvas(container, options).then(function (canvas) {
      const out = document.createElement("canvas");
      out.width = Math.ceil(sw * scale);
      out.height = Math.ceil(sh * scale);
      const ctx = out.getContext("2d");

      const srcX = Math.round(sx * scale);
      const srcY = Math.round(sy * scale);
      const srcW = Math.round(sw * scale);
      const srcH = Math.round(sh * scale);

      ctx.drawImage(canvas, srcX, srcY, srcW, srcH, 0, 0, srcW, srcH);

      return out.toDataURL("image/png");
    });
  };

  verifyAddress = () => {
    this.setState({addressModal: true},
      () => {
        this.isDisableSubmit();
      });
      this.getAddress();
  }

  hideModal = (event) => {
    this.setState({
      addressModal: false, 
      isBillAddrDiff: false,
      isBillAddrValid:true,
      isBillAddrValid:true,
      suggestions: {}
    });
  };

  formatAutocompleteSuggestion(suggestion) {
    const addressText = suggestion.address_text ? `${suggestion.address_text} ` : "";
    const street = suggestion.street_line ? `${suggestion.street_line} ` : "";
    const secondary = suggestion.secondary ? `${suggestion.secondary} ` : "";
    const entries = suggestion.entries !== 0 ? `(${suggestion.entries}) ` : "";
    const city = suggestion.city ? `${suggestion.city} ` : "";
    const state = suggestion.state ? `${suggestion.state}, ` : "";
    const zip = suggestion.zipcode ? `${suggestion.zipcode}` : "";
    const addrs = suggestion.addrs ? `${suggestion.addrs}` : "";

    return addressText + street + secondary + entries + city + state + zip + addrs;
  }

  queryAutocompleteForSuggestions(searchValue, addressId, hasSecondaries = false) {
    let zipCode = "";
    let state = "";
    if (this.state.isMailingStreet) {
      if (this.state.userAddress.postalCode) zipCode = this.state.userAddress.postalCode;
      else state = this.state.userAddress.state;
    } else if (this.state.userBillingAddress) {
      if (this.state.userBillingAddress.zip) zipCode = this.state.userBillingAddress.zip;
      else state = this.state.userBillingAddress.state;
    }

    axios.get(`${process.env.REACT_APP_SMARTY_API}/lookup?auth-id=${process.env.REACT_APP_SMARTY_AUTH_ID}&auth-token=${process.env.REACT_APP_SMARTY_AUTH_TOKEN}&include_only_zip_codes=${zipCode}&include_only_states=${state}&search=${searchValue}&address_id=${addressId}`)
      .then(results => {
        if (results.data.errors) {
          if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true}, () => this.isDisableSubmit())
            else this.setState({ isBillStreetSelected: true}, () => this.isDisableSubmit())
        }
        else this.setState({ suggestions: results.data.suggestions });
      })
      .catch(err => {
        if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true}, () => this.isDisableSubmit())
        else this.setState({ isBillStreetSelected: true}, () => this.isDisableSubmit())
      });
  }

  selectSuggestion(suggestion) {
    if (suggestion.entries > 1) {
      this.queryAutocompleteForSuggestions(this.formatAutocompleteSuggestion(suggestion, suggestion.addressId));
      // this.queryAutocompleteForSuggestions(this.formatAutocompleteSuggestion(suggestion), suggestion.addressId, true);
    } else {
      this.useAutoCompleteSuggestion(suggestion)
        .then(() => {
          if (this.state.shouldValidate) this.validateAddress();
        });
    }
  }

  useAutoCompleteSuggestion(data) {
    return new Promise(resolve => {
      if (this.state.isMailingStreet) {
        this.state.isMailStreetSelected = true
        this.setState({
          userAddress: {
            postalCode: data.zipcode,
            city: data.city.toUpperCase(),
            state: data.state.toUpperCase(),
            country: "US",
            street: data.street_line,
            addrs: this.state.userAddress.addrs
          },
          suggestions: {},
          makeCityValid: true,
          makeStateValid: true,
        }, () => {
          this.isDisableSubmit()
          return resolve
        });
      } else {
        this.handlePostalCode(data.zipcode, { flag: "BillAddr", label: "BillAddr-Zip" }, true);
        this.state.isBillStreetSelected = true
        this.setState({
          userBillingAddress: {
            zip: data.zipcode,
            city: data.city.toUpperCase(),
            state: data.state.toUpperCase(),
            country: "US",
            street: data.street_line,
            addrs: this.state.userBillingAddress.addrs
          },
          suggestions: {},
          makeBZipValid: true,
          makeBCityValid: true,
          makeBStateValid: true,
          makeBCountryValid: true,
        }, () => {
          this.isDisableSubmit()
          return resolve
        });
        // this.handlePostalCode(data.zipcode, {}, true);
      }
      this.isDisableSubmit();
    });
  }

  changeTextFieldHandler = (val, isValid, parentObj) => {
    if (parentObj.flag == "BillAddr") {
      switch (parentObj.label) {
        case "BillAddr-Zip":
          if (isValid) {
            this.state.userBillingAddress.zip = val;
            this.setState({ makeBZipValid: true })
            this.handlePostalCode(val, parentObj);
          } else {
            this.setState({ makeBZipValid: false })
            this.state.userBillingAddress.zip = "";
          }
          break;
        case "BillAddr-Street":
          this.state.userBillingAddress.street = isValid ? val : "";
          this.state.isMailingStreet = false
          this.state.isBillStreetSelected = false
          this.queryAutocompleteForSuggestions(val)
          break;
        case "BillAddr-city":
          if (isValid) {
            this.state.userBillingAddress.city = val.toUpperCase();
            this.setState({ makeBCityValid: true })
          } else {
            this.state.userBillingAddress.city = ""
            this.setState({ makeBCityValid: false })
          }
          break;
        case "BillAddr-state":
          if (isValid) {
            this.state.userBillingAddress.state = val;
            this.setState({ makeBStateValid: true })
          } else {
            this.state.userBillingAddress.state = ""
            this.setState({ makeBStateValid: false })
          }
          break;
        case "BillAddr-country":
          if (isValid) {
            this.state.userBillingAddress.country = val;
            this.setState({ makeBCountryValid: true })
          } else {
            this.state.userBillingAddress.country = ""
            this.setState({ makeBCountryValid: false })
          }
          break;
        case "BillAddr-Address":
            this.state.userBillingAddress.addrs = val;
          break;
        default:
          break;
      }
      this.isDisableSubmit();
    }
    if (parentObj.label === "Street") {
      if (isValid) {
        this.state.userAddress.street = val;
        this.state.isMailStreetSelected = false
        if(!this.state.isBillAddrDiff){
          this.state.userBillingAddress.street = val;
        }
        this.state.isMailingStreet = true
        this.queryAutocompleteForSuggestions(val)
      } else {
        this.state.userAddress.street = "";
        if(!this.state.isBillAddrDiff){
          this.state.userBillingAddress.street = '';
        }
        this.setState({suggestions: {}})
      }
      this.isDisableSubmit()
    } else if (parentObj.label === "state") {
      if (isValid) {
        this.state.userAddress.state = val;
        this.setState({ makeStateValid: true })
      } else {
        this.state.userAddress.state = "";
        this.setState({ makeStateValid: false })
      }
    } else if (parentObj.label === "city") {
      if (isValid) {
        this.state.userAddress.city = val.toUpperCase();
        this.setState({ makeCityValid: true })
      } else {
        this.state.userAddress.city = "";
        this.setState({ makeCityValid: false })
      }
    } else if (parentObj.label === "address") {
      this.state.userAddress.addrs = val;
    } 
    this.isDisableSubmit();
    this.setState(
      {
        refresh: true,
      });
  };

  isDisableSubmit = () => {
    const restBillingAddress = { ...this.state.userBillingAddress };
    delete restBillingAddress.addrs;
    const Address = { ...this.state.userAddress };
    delete Address.addrs;
    if(this.state.isBillAddrDiff){
    this.setState({
      isBillAddrValid:
      (Object.values(restBillingAddress).some(
          (x) => x === null || x === ""
        ) ||
        Object.values(Address).some(
          (x) => x === null || x === ""
        )),
    });
  } else{
      this.setState({
        isBillAddrValid:
        Object.values(Address).some(
          (x) => x === null || x === ""
          ),
      });
    }
  };

  handlePostalCode = (zipcode, parent, fromDrop) => {
    this.setState({
      loaderShow: true,
    });
   let url = `${process.env.REACT_APP_BASEURL_ROOT}agency/api/zipcode/lookup?zipcode=${zipcode}`;

    axios
      .get(url)
      .then((response) => {
        var result2 = response.data;
     if (!result2.stateAbbreviation) {
          var evt = new CustomEvent("zip_bill", {
            detail: {
              zipcode: zipcode,
              flag: true,
              errMsg: "Enter valid zip code",
            },
          });
          window.dispatchEvent(evt);
          // this.state.userBillingAddress.street = "";
          this.state.userBillingAddress.city = "";
          this.state.userBillingAddress.state = "";
          this.state.userBillingAddress.zip = "";
          this.state.userBillingAddress.country = "US";
          // this.state.userBillingAddress.addrs = "";
          this.setState(
            {
              refresh: true,
              loaderShow: false,
            },
            () => this.isDisableSubmit()
          );
        } else {
          axios
            .get(
              configuration.baseUrl +
                "/plan/validateBlackListState/" +
                result2.stateAbbreviation
            )
            .then((response) => {
              this.setState({
                loaderShow: false,
              });

              if (!response.data.response) {
                if(!fromDrop) this.state.userBillingAddress.street = "";
                else this.state.isValidBillingZip = true
                this.state.userBillingAddress.city =
                  result2.city;
                this.state.userBillingAddress.state =
                  result2.stateAbbreviation;
                this.state.userBillingAddress.zip =
                  result2.zipcode;
                this.state.userBillingAddress.country = "US";
                this.setState(
                  {
                    refresh: true,
                    loaderShow: false,
                  },
                  () => this.isDisableSubmit()
                );
              } else {
                this.state.userBillingAddress.city = "";
                this.state.userBillingAddress.state = "";
                this.state.userBillingAddress.zip = "";
                this.state.userBillingAddress.country = "US";
                this.state.userBillingAddress.addrs = "";
                this.state.userBillingAddress.street = "";
                var evt = new CustomEvent("zip_bill", {
                  detail: {
                    zipcode: zipcode,
                    flag: true,
                    errMsg: "Programs are not offered in this zip code",
                    parentDetails: parent,
                  },
                });
                window.dispatchEvent(evt);
                this.setState(
                  {
                    refresh: true,
                    loaderShow: false,
                  },
                  () => {
                    this.changeTextFieldHandler(zipcode, false, parent);
                  }
                );
              }
            });
        }
      })
      .catch((error) => {
        let evt = new CustomEvent("zip_bill", {
          detail: {
            zipcode: zipcode,
            flag: true,
            errMsg: "Enter valid zip code",
          },
        });
        window.dispatchEvent(evt);
        this.state.userBillingAddress.city = "";
        this.state.userBillingAddress.state = "";
        this.state.userBillingAddress.zip = "";
        this.state.userBillingAddress.country = "US";
        this.state.userBillingAddress.addrs = "";
        this.state.userBillingAddress.street = "";
        this.setState(
          {
            refresh: true,
            loaderShow: false,
            msgModal: true,
          },
          () => {
            this.changeTextFieldHandler(zipcode, false, parent);
          }
        );
      });
  };

  submitAddress = (e) => {
    this.setState({submitWaitModal: true})
    let obj = new Object();
    obj.street = this.state.userAddress.street;
    obj.country = this.state.userAddress.country;
    obj.city = this.state.userAddress.city;
    obj.state = this.state.userAddress.state;
    obj.postalCode = this.state.userAddress.postalCode;
    obj.subId = this.props.subId;
    obj.visit = this.state.userAddress.addrs;
    let billObj = {
      "subId": this.props.subId,
      "mailAddress1": this.state.isBillAddrDiff ? this.state.userBillingAddress.street : this.state.userAddress.street,
      "mailCountry": this.state.isBillAddrDiff ? this.state.userBillingAddress.country : this.state.userAddress.country,
      "mailCity": this.state.isBillAddrDiff ? this.state.userBillingAddress.city : this.state.userAddress.city,
      "mailState": this.state.isBillAddrDiff ? this.state.userBillingAddress.state : this.state.userAddress.state,
      "mailPostalCode": this.state.isBillAddrDiff ? this.state.userBillingAddress.zip : this.state.userAddress.postalCode,
      "address2": this.state.isBillAddrDiff ? this.state.userBillingAddress.addrs : this.state.userAddress.addrs
    }
    obj = {...billObj,...obj};
    if (e.detail === 1)
    axios
      .post(configuration.baseUrl + "/setupfamily/addMemberAddress", obj)
      .then((response) => {
        if (response.data.code === 200) {
          this.setState({
            addressModal: false,
            waitingRes: "true",
            loaderShow: false,
            isBillAddrDiff: false,
            isBillAddrValid:true,
          });
          this.beforeSaveApplication();
        }
      })
  }

  beforeSaveApplication = async () => {
    console.log('--------- brfore ----------');
    this.setState({
      isSaved: false
    });
    let stateParams= JSON.parse(sessionStorage.getItem("STATE_PARAM"));

    if (this.state.signType === "stylized") {
      const img = await this.textSignatureToImage();
      await this.uploadImage(this.dataURItoBlob(img));
    }

    if (this.state.signType === "scribble") {
      await this.uploadImage(this.dataURItoBlob(this.state.imageSource));
    }
    if(stateParams && stateParams.source && stateParams.source.source === "agency"){
      let object = {
        admin: stateParams.source.email,
        user: stateParams.user_subId,
        reason:"Push enrollment from agency",
        sourceApplication:"Agency"
      }
      axios.post(configuration.baseUrl + "/enrollmentaudit/saveErollmentAudit", object);
    }else{
      let object = {
        admin: localStorage.getItem("userMail"),
        user: localStorage.getItem("userMail"),
        reason:"",
        sourceApplication:"Enrollment"
      }
      axios.post(configuration.baseUrl + "/enrollmentaudit/saveErollmentAudit", object);
    }

    let obj = new Object();
    obj.subId = this.state.subID;
    obj.signedName = this.state.fullName;
    obj.esign = this.state.imgUrl;
    obj.enrollFlag = true;
    await axios
      .post(configuration.baseUrl + "/enrollment/saveAuthorization", obj)
      .then((response) => {
        if (response.data.code === 200) {
          fetch(
            configuration.baseUrl + "/plan/getMemberPlan/" + this.state.subID+"/Core"
          )
            .then((selectedPlan) => selectedPlan.json())
            .then((selectedPlan) => {
              // if (
              //   (this.state.fromMember == false &&
              //     this.state.fromLogin == false) ||
              //   this.state.enroll
              // ) {
                if (selectedPlan.response) {
                  let date = moment(selectedPlan.response.targetDate).format("MM") + "/" + moment(selectedPlan.response.targetDate).format("DD") + "/" + moment(selectedPlan.response.targetDate).format("YYYY");
                  let now = moment().format("MM") + "/" + moment().add(1, 'days').format("DD") + "/" + moment().format("YYYY");

                  if ((new Date(date) < new Date(now) || selectedPlan.response.targetDate == null || selectedPlan.response.targetDate == "") && !this.state.payflag) {
                    this.setState({
                      targetDate: date,
                      targetDateModal: true,
                      loaderShow: false,
                      submitWaitModal: false
                    });
                  } else {
                    this.setState({submitWaitModal: true})
                    this.saveApplication();
                  }
                }
            });
        }
      });
  };

  closeWindow = () =>{
    localStorage.removeItem('selectedAddon')
    sessionStorage.removeItem("STATE_PARAM");
    sessionStorage.removeItem("STATE_VAL");
    sessionStorage.removeItem("CLIENT_ID");
    sessionStorage.removeItem("CHAT_BOX_Id");
    cookies.remove("STATE_PARAM", { path: "/" });
    window.top.postMessage(
      JSON.stringify({
        message: 'GoToDashboard',
        subID: this.statesubID
      }),
      '*'
    );
    window.close();
}

  saveApplication = async (isAgent) => {
    if (isAgent) this.setState({ loaderShow: true })
    await this.getEnrollFlagDetails()
    console.log("payflag---", this.state.payflag);
    let data = new Object();
    data.subId = this.state.subID;
    data.email = this.state.email;

    if (this.state.payflag == false) {
      if (!isAgent) {
        this.setState({
          submitDone: true,
        });
      } else {
        this.setState({
          submitDone: true,
          successModal: false,
        });
      }
    } else if (this.state.payflag == true) {
      this.setState({
        submitDone: true,
        successModal: false,
      });
    } else {
      this.setState({
        submitDone: true,
      });
    }

    if (this.state.inEnrolledState) {
      let evt = new CustomEvent("enroll_flag", {
        detail: { flag: true },
      });
      window.dispatchEvent(evt);
      localStorage.removeItem("paymentData");
      localStorage.removeItem("PAYMENT_ERROR");
      // Clear quick quote data after successful submission
      sessionStorage.removeItem("QUICK_QUOTE_ZIPCODE");
      sessionStorage.removeItem("QUICK_QUOTE_SELECTED_DATA");
      this.setState({
        submitDone: true,
        successModal: false,
        count: 5,
        loaderShow: false,
        isSaved: true,
        // statusModal: false,
        submittedModal: true,
        planSelectionModal: false,
        submitWaitModal: false
      });
    } else if (isAgent) {
      this.setState({ loaderShow: true })
      fetch(
        configuration.baseUrl +
        "/enrollment/saveEnrollmentMember/" +
        this.state.subID
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.code === 200) {
            let evt = new CustomEvent("enroll_flag", {
              detail: { flag: true },
            });
            window.dispatchEvent(evt);
            localStorage.removeItem("paymentData");
            localStorage.removeItem("PAYMENT_ERROR");
            // Clear quick quote data after successful submission
            sessionStorage.removeItem("QUICK_QUOTE_ZIPCODE");
            sessionStorage.removeItem("QUICK_QUOTE_SELECTED_DATA");
            this.setState({
              submitDone: true,
              successModal: false,
              count: 5,
              loaderShow: false,
              isSaved: true,
              // statusModal: false,
              submittedModal: true,
              planSelectionModal: false
            });
          } else if (response.code === 202) {
            this.setState({
              loaderShow: false,
              submitDone: false,
              successModal: true,
              isSaved: true,
              popUpMsg:
                "The enrollment application has already been submitted and is being processed.",
            });
          } else if (response.code === 500) {
            this.setState({
              loaderShow: false,
              submitDone: false,
              successModal: true,
              isSaved: true,
              popUpMsg:
                "There was an error in processing the enrollment. Please try again later.",
            });
          } else {
            this.setState({
              loaderShow: false,
              submitDone: false,
              successModal: true,
              isSaved: true,
              popUpMsg:
                "There was an error in processing the enrollment. Please try again later.",
            });
          }
        })
        .catch((error) => {
          this.setState({
            loaderShow: false,
            submitDone: false,
            successModal: true,
            isSaved: true,
            popUpMsg:
              "There was an error in processing the enrollment. Please try again later.",
          });
        });
      this.setState({ planSelectionModal: false })
    } else {
       const fp = await FingerprintJS.load();
        const result = await fp.get();
        let fingerprintId = result.visitorId
        let time = getDateTime();
      axios
        .post(`${configuration.baseUrl}/enrollment/enrollment?deviceFingerprint=${fingerprintId}`, data,
          {
            headers: {
              'X-Timestamp': time.dateTime, // Or your specific timestamp variable
              'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone, // Gets user's timezone automatically
              'Content-Type': 'application/json'
            }
          }
        )
        .then((response) => {
          if (response.data.code === 200) {
            let evt = new CustomEvent("paymentFlag", {
              detail: { flag: true },
            });
            window.dispatchEvent(evt);

            let evt1 = new CustomEvent("enroll_flag", {
              detail: { flag: true },
            });
            window.dispatchEvent(evt1);
            localStorage.removeItem("paymentData");
            localStorage.removeItem("PAYMENT_ERROR");
            // Clear quick quote data after successful submission
            sessionStorage.removeItem("QUICK_QUOTE_ZIPCODE");
            sessionStorage.removeItem("QUICK_QUOTE_SELECTED_DATA");
            this.setState({
              submitDone: true,
              successModal: false,
              count: 5,
              loaderShow: false,
              isSaved: true,
              submitWaitModal: false
            });
          } else if (response.data.code === 202) {
            this.setState({
              loaderShow: false,
              successModal: true,
              count: 4,
              popUpMsg: JSON.parse(response.data.response).error_message,
              submitWaitModal: false
            });
          } else if (response.data.code === 204) {
            this.setState({
              loaderShow: false,
              successModal: true,
              count: 4,
              popUpMsg: "The enrollment application has already been submitted and is being processed.",
              submitWaitModal: false
            });
          } else if (response.data.code === 500) {
            this.setState({
              loaderShow: false,
              count: 4,
              successModal: true,
              popUpMsg:
                "There was an error in processing the enrollment. Please try again later.",
              submitWaitModal: false
            });
          } else if (response.data.code === 0) {
            this.setState({
              loaderShow: false,
              submitDone: false,
              isSaved: true,
              successModal: true,
              popUpMsg:
                "There was an error in processing the enrollment. Please try again later.",
              submitWaitModal: false
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ submitWaitModal: false })
        });
    }
  };

  changeBillAddreDiff = () => {
    let value = !this.state.isBillAddrDiff;
    this.setState({ isBillAddrDiff: value, userBillingAddress: value ? {
      zip: '',
      city:'',
      state: '',
      country: '',
      street: '',
      addrs: ''
    }:{
      zip: this.state.userAddress.postalCode,
      city: this.state.userAddress.city,
      state: this.state.userAddress.state,
      country: this.state.userAddress.country,
      street: this.state.userAddress.street,
      addrs: this.state.userAddress.addrs
    }},()=>this.isDisableSubmit());
  };

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = (event) => {
    if (event.data === 'closePLAID') {
      console.log('Iframe sent close message.');
      this.setState({ showPlaid: false })
    }
  };

  async componentDidMount() {
    window.addEventListener("message", this.handleMessage)
    window.addEventListener("message", function (event) {
      if (event.data === "closeIframe") {
        console.log("Message received from iframe: closeIframe");
        this.setState({ showPlaid: false, loaderShow: true });
        fetch(`${process.env.REACT_APP_paymentService}customers/achCancel/${this.props.subId}`)
          .then(res => {
            axios.get(`${process.env.REACT_APP_paymentService}customers/ACH/${this.props.subId}`)
              .then((response) => {
                if (response.data.data.achVerificationStatus != "VERIFIED") {
                  this.setState({ isACHFailed: true })
                }
                this.setState({ loaderShow: false })
              })
          })
      }
    }.bind(this), false);
    this.getPaymentMode()
    if (sessionStorage.getItem("notHLC") === "true")
      sessionStorage.setItem("current_screen", "9");
    else {
      sessionStorage.setItem("current_screen", "8");
    }
    let subId = JSON.parse(localStorage.getItem('CurrentLoginUser')).id;
    axios.get(configuration.baseUrl + "/enrollment/saveCompletionStatus/" + subId + "/" + sessionStorage.getItem('current_screen'))
      .then((response) => {
        if (response && response.data.code === 200) console.log(response.data.code)
      })
      .catch((error) => console.log(error));

    this.setState({
      loaderShow: true,
      privacyPolicy: false,
      authorize1: false,
      authorize: false,
      authorization: false,
      checkBox5: false,
      checkBox7: false,
      checkBox8: false,
    });
    let cookiesData = null;
    cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")); //cookies.get('STATE_PARAM', false);
    if (cookiesData && cookiesData.fromMember) {
      this.setState({ fromMember: true, fromLogin: false, isAdmin: cookiesData.isAdmin? cookiesData.isAdmin: false }); // for go to step select program
    } else if (cookiesData && cookiesData.fromLogin === true) {
      this.setState({ fromLogin: true, fromMember: false }); // for go to step select program
    } else {
      this.setState({ enroll: true });
    }

    let URL = "";
    if (this.props.isAgent) {
      //
      if (cookiesData && cookiesData.reEnrolledByAgent == true) {
        // from agent after enrolled
        this.setState({
          paymentScreenModal: true,
        });
      } else if (
        (cookiesData && cookiesData.fromMember == true) ||
        cookiesData.fromLogin == true
      ) {
        // from member
        this.setState({
          paymentScreenModal: false,
        });
      } else {
        axios
          .get(
            configuration.baseUrl +
              "/setupfamily/getMemberBySubID/" +
              this.state.subID
          )
          .then((response) => {
            if (response.data.response) {
    
              if (this.props.isAgent) {
                if(response.data.response.emailFlag)
                this.setState({
                  emailFlag: response.data.response.emailFlag,
                  paymentScreenModal: false,
                  sourceid: response.data.response.id,
                  statusModal: true,
                },()=>{
                  this.getContactEmailDetails();
                });
                else
                this.setState({
                  paymentScreenModal: true,
                  statusModal: false
                }, ()=>{
                  this.getContactEmailDetails()
                });
              }
            }})

      }
    }else{
      axios.get(
        configuration.baseUrl +
        "/plan/getTermsAndConditionLink/" +
        this.state.subID
      ).then((response)=>{
        this.setState({termsAndConditionLink: response.data.response})
      })
      
    }

    let getDetails = JSON.parse(localStorage.getItem("CurrentLoginUser"));

    if (getDetails.email !== null || getDetails.email !== "") {
      this.setState({
        email: getDetails.email,
        oldEmail: getDetails.email,
      });
    }

    console.log("=====agentDetails===");
    console.log(this.props.agentDetails);

    if (this.props.agentDetails && this.props.agentDetails.brokerId) {
      axios
        .get(
          configuration.agentURL +
            "/agentlogin/getAgentById/" +
            this.props.agentDetails.brokerId
        )
        .then((response) => {
          console.log("===RESPONSE===", response.data.response);
          this.setState({
            agentName:
              response.data.response.firstName +
              " " +
              response.data.response.lastName,
          });
        });
    }

    if (this.props.isAgent) {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlagBySubId/" +
        getDetails.id; //this.props.agentDetails.subId
    } else {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlag/" +
        this.props.email;
    }
    //axios.get(configuration.baseUrl + '/setupfamily/getEnrollFlag/' + this.props.email)
    await axios.get(URL).then((response) => {
      let enFlag = response.data.response.enrollFlag;
      let paymentFlag = response.data.response.paymentFlag;
      let agentFlag = response.data.response.agentFlag;
      reenrollmentFlag = response.data.response.reenrollmentFlag
        ? response.data.response.reenrollmentFlag
        : false;
      this.setState({
        payflag: paymentFlag,
        subID: response.data.response.subId,
        isEnrolled: paymentFlag
      });
      if (
        cookiesData &&
        (cookiesData.reEnrolledByAgent == false ||
          cookiesData.fromMember == false ||
          cookiesData.fromLogin == false)
      ) {
        axios
          .get(
            configuration.baseUrl +
              "/enrollment/getAuthorization/" +
              this.state.subID
          )
          .then((response) => {
            if (response.data.code === 200) {
              if (response.data.response.policy) {
                this.setState({
                  // privacyPolicy: true,
                  // authorize: true,
                  // authorize1: true,
                  // authorize44: true,
                  healthTerms: response.data.response.sharePolicy,
                  authorization: response.data.response.financialPolicy,
                });
              } else {
                this.setState({
                  privacyPolicy: false,
                  authorize: false,
                  authorize1: false,
                  authorize44: false,
                  healthTerms: response.data.response.sharePolicy,
                  authorization: response.data.response.financialPolicy,
                });
              }

              if (enFlag || paymentFlag) {
                this.setState({
                  count: 5,
                  submitDone: true,
                  planSelectionModal: false,
                  enrollFlag: enFlag,
                  loaderShow: false,
                });
              } else {
                if (agentFlag && !this.props.isAgent && !enFlag) {
                  if (
                    response.data.response.policy &&
                    response.data.response.sharePolicy &&
                    response.data.response.financialPolicy
                  ) {
                    this.setState(
                      {
                        planSelectionModal: true,
                        loaderShow: true,
                        count: 4,
                        enrollFlag: enFlag,
                        progress: (4 / 4) * 100,
                      },
                      () => this.getPlanData()
                    );
                  } else {
                    this.setState(
                      {
                        planSelectionModal: true,
                        loaderShow: true,
                        enrollFlag: enFlag,
                      },
                      () => this.getPlanData()
                    );
                  }
                } else {
                  if (
                    response.data.response.policy &&
                    response.data.response.sharePolicy &&
                    response.data.response.financialPolicy
                  ) {
                    this.setState({
                      count: 3,
                      submitDone: false,
                      paymentScreenModal: true,
                      enrollFlag: enFlag,
                      loaderShow: false,
                      progress: (3 / 4) * 100,
                    });
                  } else {
                    this.setState({
                      count: 1,
                      submitDone: false,
                      enrollFlag: enFlag,
                      loaderShow: false,
                    });
                  }
                }
              }
            }
            this.getDisabled();
          });
      } else {
        if (enFlag || paymentFlag && !this.props.isAgent && !reenrollmentFlag) {
          this.setState({
            count: 5,
            submitDone: true,
            planSelectionModal: false,
            enrollFlag: enFlag,
            loaderShow: false,
          });
        } else {
          this.setState({
            loaderShow: false,
            count: 1,
            privacyPolicy: false,
            authorize: false,
            authorize1: false,
            authorize44: false,
            healthTerms: false,
            authorization: false,
            enrollFlag: true,
            planSelectionModal:
              cookiesData != null
                ? cookiesData.reEnrolledByAgent
                  ? false
                  : true
                : true,
          });
        }
      }
    });

    axios
      .get(
        configuration.baseUrl +
          "/plan/viewQuote/" +
          this.state.subID +
          "/summary"
      )
      .then((response) => {
        const resp = response.data && response.data.response;
        const hasAllstate = resp && Array.isArray(resp.body) && resp.body.some(item => item && item.text && item.text.toLowerCase().includes('allstate'));
        this.setState(
          {
            tableData: resp,
            popTable: resp,
            showOnlyAllstateCheckbox: !!hasAllstate
          }
        );
      });


      let efectiveDate = new Date();
      let myNwDate = new Date();
      console.log('new------------------');
      if(sessionStorage.getItem('CLIENT_ID') === '1004' || sessionStorage.getItem('CLIENT_ID') === '1005' || sessionStorage.getItem('CLIENT_ID') === '1006' || sessionStorage.getItem('CLIENT_ID') === '1007' || sessionStorage.getItem('CLIENT_ID') === '1008' || sessionStorage.getItem('CLIENT_ID') === '1010'){
         
        myNwDate.setDate(1);
        myNwDate.setMonth(new Date(efectiveDate).getMonth() + 1);
        this.setState({minDate: new Date(myNwDate)})
      }
      if(true ){
          let myNDate = new Date();
          myNDate.setDate(myNDate.getDate() + 5);
          console.log('my date+++++++++++++++', new Date(myNDate));
          this.setState({minDate: new Date(myNDate)})
      }
      let data={
        "clientId" : sessionStorage.getItem('CLIENT_ID')
      }
    axios.post(configuration.baseUrl + '/enrollment/getClient', data)
      .then(response => {
        if (response.data.response) {
          this.setState({
            myAppFee: response.data.response.appFee
          });
        }
      });
      this.getWaitingPeriodSummary();
      this.getProgamInformation();
      if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
        this.setState({
          countryCode: "+91",
        });
      }
      this.getAddress();
  }

  getPaymentMode = () => {
    fetch(`${configuration.baseUrl}/setuppayment/getPaymentDetails/${this.props.subId}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.response) {
          if (response.response.paymentType === "ACH")
            this.setState({ achSelected: true })
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  checkACH = () => {
    if (this.state.achSelected) {
      axios.get(process.env.REACT_APP_paymentService + 'customers/ACH/' + this.props.subId)
        .then((response) => {
          console.log('res - ', response.data.data);
          this.setState({ achData: response.data.data }, () => {
            if (this.state.achData.achVerificationStatus != "VERIFIED") {
              fetch(`${process.env.REACT_APP_paymentService}customers/generatePlaidLink/${this.props.subId}`)
                .then((response) => response.json())
                .then((response) => {
                  this.setState({ showPlaid: true, plaidLink: response.data })
                })
            }
          })
        })
    }
  }

  getEnrollFlagDetails = async () => {
    let cookiesData = null;
    cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")); 
    let getDetails = JSON.parse(localStorage.getItem("CurrentLoginUser"));

    if (getDetails.email !== null || getDetails.email !== "") {
      this.setState({
        email: getDetails.email,
        oldEmail: getDetails.email,
      });
    }

    console.log("=====agentDetails===");
    console.log(this.props.agentDetails);

    if (this.props.agentDetails && this.props.agentDetails.brokerId) {
      axios
        .get(
          configuration.agentURL +
            "/agentlogin/getAgentById/" +
            this.props.agentDetails.brokerId
        )
        .then((response) => {
          console.log("===RESPONSE===", response.data.response);
          this.setState({
            agentName:
              response.data.response.firstName +
              " " +
              response.data.response.lastName,
          });
        });
    }

    if (this.props.isAgent) {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlagBySubId/" +
        getDetails.id; //this.props.agentDetails.subId
    } else {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlag/" +
        this.props.email;
    }
    //axios.get(configuration.baseUrl + '/setupfamily/getEnrollFlag/' + this.props.email)
    await axios.get(URL).then((response) => {
      let enFlag = response.data.response.enrollFlag;
      let paymentFlag = response.data.response.paymentFlag;
      let agentFlag = response.data.response.agentFlag;
      reenrollmentFlag = response.data.response.reenrollmentFlag
        ? response.data.response.reenrollmentFlag
        : false;
      this.setState({
        payflag: paymentFlag,
        subID: response.data.response.subId,
        isEnrolled: paymentFlag,
        inEnrolledState: enFlag,
      });
      if(enFlag){
        this.setState({
          count: 5,
        });
      }
      if (
        cookiesData &&
        (cookiesData.reEnrolledByAgent == false ||
          cookiesData.fromMember == false ||
          cookiesData.fromLogin == false)
      ) {
      } else {
        if (enFlag && paymentFlag && !this.props.isAgent && !reenrollmentFlag) {
          this.setState({
            count: 5,
            submitDone: true,
            planSelectionModal: false,
            enrollFlag: enFlag,
            // loaderShow: false,
          });
        } else {
          this.setState({
            // loaderShow: false,
            privacyPolicy: false,
            authorize: false,
            authorize1: false,
            authorize44: false,
            healthTerms: false,
            authorization: false,
            enrollFlag: true,
          });
        }
      }
    });
  }

  getAddress = () => {
    fetch(
      configuration.baseUrl + "/setupfamily/getMemberInfo/" + this.state.subID
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState(
          {
            userAddress: {
              postalCode: response.response.postalCode,
              city: response.response.city,
              state: response.response.state,
              country: response.response.country,
              street: response.response.street ? response.response.street : "",
              addrs: response.response.visit || ""
            },
            isMailStreetSelected: response.response.street ? true : false,
            isBillStreetSelected: response.response.postalCode === response.response.mailPostalCode ? response.response.street ? true : false : response.response.mailAddress1 ? true : false,
            isBillAddrDiff : response.response.postalCode === response.response.mailPostalCode ? false : response.response.mailPostalCode ? true : false,
            userBillingAddress: response.response.postalCode === response.response.mailPostalCode || response.response.mailPostalCode === null ? 
            {
              zip: response.response.postalCode,
              city: response.response.city,
              state: response.response.state,
              country: response.response.country,
              street: response.response.street ? response.response.street : "",
              addrs: response.response.visit || ""
            }:
            {
              zip: response.response.mailPostalCode,
              city: response.response.mailCity,
              state: response.response.mailState,
              country: response.response.mailCountry,
              street: response.response.mailAddress1,
              addrs: response.response.address2 || ""
            },
            loaderShow: false,
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getProgamInformation=() => {
    // axios.get(configuration.baseUrl +"/plan/getProgramInformation/"+this.state.subID).then((response) => {
    //   this.setState({programInfo:response.data.response})
    // })
    // axios.get(process.env.REACT_APP_BASE_URL+`/enrollment/generateQuestionAnswer/${this.state.subID}`).then((response)=>{
    //  this.setState({htmlMedicalInfo: response.data})
    // })
  }
  getPlanData = () => {
    fetch(configuration.baseUrl + "/plan/getMemberPlan/" + this.state.subID+"/Core")
      .then((selectedPlan) => selectedPlan.json())
      .then((selectedPlan) => {
        let sharingPlan = selectedPlan.response.planId;
        let selectedPlanCode = selectedPlan.response.planCode;
        fetch(
          configuration.baseUrl +
            "/plan/quoteByPlanSummary/" +
            this.state.subID +
            "/Netwell"
        )
          .then((res) => res.json())
          .then((res) => {
            let amt = res.quote[res.quote.length - 1].amount.split("$");
            let surcharge =
              res.quote[res.quote.length - 1].surcharge.split("$");
            let val = parseFloat(amt[1]) + parseFloat(surcharge[1]);
            this.setState({
              planFamilyDetails: res.quote,
              headerData: res.header,
              loaderShow: false,
              otherQuote: res.selectPlan,
              text: res.text.text,
              todayPayment: res.todayPayment,
              recurringPayment: res.recurringPayment,
              totalCost: val.toFixed(2),
              sharingPlan: sharingPlan,
              selectedPlanCode: selectedPlanCode,
              tooltipData: res.surchargeTooltip,
              totalPayment: res.total,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getContactEmailDetails=()=>{
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    let phone;
    if (CurrentLoginUser.phone.length === 13) {
      phone = CurrentLoginUser.phone.substr(3);
    } else {
      phone = CurrentLoginUser.phone.substr(2);
    }
    this.setState({
      phoneNumber: phone, 
      email: CurrentLoginUser.email,
      countryCode: (Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta")?"+91":"+1"
    })
  }
  viewPlanHideModalHealth = (event) => {
    this.setState(
      {
        modalShow: false,
        healthTerms: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  viewPlanHideModalHealth11 = (event) => {
    this.setState({
      modalShow: false,
      healthTerms: false,
    });
  };

  viewPlanHideModalHealth1 = (event) => {
    if (this.state.healthTerms == false) {
      this.setState(
        {
          modalShow: false,
          healthTerms: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShow: false,
          healthTerms: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showPlansModalHealth = (event) => {
    this.setState(
      {
        modalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  handleClose = (event) => {
    if (sessionStorage.getItem("notHLC") === "true") {
      sessionStorage.setItem("current_screen", "9");
    } else {
      sessionStorage.setItem("current_screen", "8");
    }

    let currentScreen = sessionStorage.getItem("current_screen");

    if (this.props.isAgent) {
      axios
        .get(
          configuration.baseUrl +
            "/enrollment/saveCompletionStatus/" +
            this.state.subID +
            "/" +
            currentScreen
        )
        .then((response) => {
          if (response && response.data.code === 200) {
            // sessionStorage.removeItem("STATE_PARAM");
            // sessionStorage.removeItem("STATE_VAL");
            // sessionStorage.removeItem("CLIENT_ID");
            // sessionStorage.removeItem("CHAT_BOX_Id");
            // cookies.remove("STATE_PARAM", { path: "/" });
            // window.close();
            this.setState({statusModal: true, successModal: false, paymentScreenModal: false,})

          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.getEnrollFlagDetails()
      this.setState({

        successModal: false,
      });
    }
  };

  handlerCopy(e) {
    e.preventDefault();
  }

  getDisabled = () => {
    if (this.state.count === 1) {
      if (this.state.showOnlyAllstateCheckbox) {
        // When only Allstate checkbox should be shown, require checkBox6 and checkBoxAllstate
        if (this.state.checkBox6 &&

          this.state.checkBoxFirst &&
          this.state.checkBoxAllstate &&
          this.state.checkBoxSecond &&
        (this.state.checkBoxThird || process.env.REACT_APP_AEC === "true")) {
          this.setState({ nextDisabled: false });
        } else {
          this.setState({ nextDisabled: true });
        }
      } else {
        if (
          // this.state.privacyPolicy &&
          // this.state.authorize &&
          // this.state.authorize1 &&
          // this.state.checkBox5 &&
          this.state.checkBox6 &&

          this.state.checkBoxFirst &&
          this.state.checkBoxSecond &&
          (this.state.checkBoxThird || process.env.REACT_APP_AEC === "true")
          // this.state.checkBoxFourth &&
          // this.state.checkBoxSixProgramSummary
        ) {
          /* this.state.authorize44 */
          this.setState({ nextDisabled: false });
        } else {
          this.setState({ nextDisabled: true });
        }
      }
    } else if (this.state.count === 2) {
      this.setState({
        nextDisabled: !this.state.authorization,
      });
    } else if (this.state.count === 3) {
      this.setState({
        nextDisabled: !this.state.healthTerms,
      });
    } else if (this.state.count === 4) {
      this.setState({
        nextDisabled: true,
      });
    }
  };

  handleLogout = () => {
    this.setState({
      loaderShow: true,
    });

    let currentScreen = sessionStorage.getItem("current_screen");

    axios
      .get(
        configuration.baseUrl +
          "/enrollment/saveCompletionStatus/" +
          this.state.subID +
          "/" +
          currentScreen
      )
      .then((response) => {
        if (response && response.data.code === 200) {
          Auth.signOut();
          localStorage.clear();
          sessionStorage.removeItem("STATE_PARAM");
          sessionStorage.removeItem("STATE_VAL");
          sessionStorage.removeItem("CLIENT_ID");
          sessionStorage.removeItem("CHAT_BOX_Id");
          localStorage.setItem("isLogged", false);
          sessionStorage.setItem("isLogged", false);
          cookies.remove("STATE_PARAM", { path: "/" });
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getEmailPhoneDetails = (requestType) => {
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    let stateParams = JSON.parse(sessionStorage.getItem("STATE_PARAM"));
    if (
      CurrentLoginUser.email == null ||
      CurrentLoginUser.email == "" ||
      CurrentLoginUser.phone == null ||
      CurrentLoginUser.phone == ""
    ) {
      if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
        this.setState({
          countryCode: "+91",
        });
      }

      this.setState({
        loaderShow: true,
        emailPhoneModal: true,
        // emailModal: true,
        reqType: requestType,
      });
    } else {
      if (stateParams.reEnrolledByAgent === true && requestType !== "sms") {
        this.setState({
          emailModal: true,
          loaderShow: false,
          reqType: requestType,
          email: CurrentLoginUser.email,
          oldEmail: CurrentLoginUser.email,
        });
      } else {
        this.goToAgentDashboard(requestType);
      }
    }
  };

  getInviteStatus = (requestType, phone) => {
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    axios
      .get(
        configuration.baseUrl +
          "/setupfamily/getMemberBySubID/" +
          this.state.subID
      )
      .then((response) => {
        if (response.data.response) {
          let data = JSON.parse(JSON.stringify(response.data.response));
          console.log("---Invite status---", data.inviteStatus);
          this.setState(
            {
              inviteStatus:
                data.inviteStatus != null
                  ? moment(data.inviteStatus).format("DD MMM YYYY hh:mm a")
                  : null,
              reqType: requestType,
              phoneNumber: phone,
              loaderShow: false,
            },
            () => {
              if (this.state.inviteStatus == null) {
                this.setState({
                  emailModal: true,
                  loaderShow: true,
                  reqType: requestType,
                  email: CurrentLoginUser.email,
                  oldEmail: CurrentLoginUser.email,
                });
                // this.sendAuthRequest(requestType, phone);
              } else {
                this.setState({
                  loaderShow: false,
                  inviteStatusModal: true,
                });
              }
            }
          );
        }
      });
  };

  closeInviteStatusModal = () => {
    this.setState(
      {
        inviteStatusModal: false,
        inviteStatus: "",
      },
      () => this.handleClose()
    );
  };

  goToAgentDashboard = (requestType) => {
    this.setState({
      loaderShow: true,
      paymentScreenModal: false,
    });
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    if (requestType === "email") {
      if (CurrentLoginUser.email == this.state.email) {
        if (this.state.inviteStatusFlag == false) {
          this.getInviteStatus(requestType, CurrentLoginUser.phone);
        } else {
          this.setState({
            emailModal: true,
            loaderShow: true,
            reqType: requestType,
            email: CurrentLoginUser.email,
            oldEmail: CurrentLoginUser.email,
          });
          // this.sendAuthRequest(requestType, CurrentLoginUser.phone);
        }
      } else {
        let cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM"));
        let dataObj = {
          subId: cookiesData.subID,
          email: this.state.email.toLowerCase(),
          oldEmail: this.state.email.toLowerCase(),
          phone: CurrentLoginUser.phone,
        };
        console.log("--SAVE EMAIL CALL --", dataObj);
        axios
          .post(configuration.baseUrl + "/setupfamily/saveEmail", dataObj)
          .then((response) => {
            if (response.data.code === 200) {
              if (this.state.inviteStatusFlag == false) {
                this.getInviteStatus(requestType, CurrentLoginUser.phone);
              } else {
                this.setState({
                  emailModal: true,
                  loaderShow: true,
                  reqType: requestType,
                  email: CurrentLoginUser.email,
                  oldEmail: CurrentLoginUser.email,
                });
                // this.sendAuthRequest(requestType, CurrentLoginUser.phone);
              }
            }
          });
      }
    } else if (requestType === "sms") {
      let phone = "";
      if (CurrentLoginUser.phone.length === 13) {
        phone = CurrentLoginUser.phone.substr(3);
      } else {
        phone = CurrentLoginUser.phone.substr(2);
      }
      if(Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta"){
        this.setState({
          countryCode: "+91",
          contactModal: true,
          phoneNumber: phone,
        });
      }else{
        this.setState({
          countryCode: "+1",
          contactModal: true,
          phoneNumber: phone,
        });
      }
    }
  };

  setUserValue = async (value, isValid, parentDetails) => {
    if (parentDetails.name === "email") {
      if (isValid) {
        this.setState(
          {
            email: value,
            newEmail: value,
            validationError:false
          },
          () => {
            this.checkEmailPhone();
          }
        );
      } else {
        this.setState({
          email: "",
          isvalidEmailPhone: true,
          validationError:false
        });
      }
    } else if (parentDetails.name === "phone") {
      const phoneno = await this.getCleanNumber(value);
      const prevLen = this.state.prevPhoneLen || 0;
      const isIncreasing = phoneno.length > prevLen || phoneno.length === 10;

      this.setState({ prevPhoneLen: phoneno.length });

      if (isIncreasing && (phoneno.length === 3 || phoneno.length === 10)) {
        axios
          .get(
            process.env.REACT_APP_enrollment_base_url +
            "/enrollment/phoneCode/" +
            phoneno
          )
          .then((response) => {
            if (response?.data?.code === 202) {
              this.setState({
                loaderShow: false,
                msgModal: true,
                phoneNumber: '',
                prevPhoneLen:0,
                validationError: true,
                errMsg:
                  phoneno.length === 3
                    ? "This area code is blocked under TCPA policy. Please use a different number or contact Support."
                    : "This phone number is blocked under TCPA policy and cannot be used for enrollment or account changes.",
              });
            } else if (response?.data?.code === 200) {
              this.setState(
                {
                  phoneNumber: value,
                  validationError: false,
                },
                () => this.checkEmailPhone()
              );
            }
          })
          .catch(() => {
            this.setState({
              loaderShow: false,
              msgModal: true,
              errMsg:
                "Oops! Something's not right. If you're still having trouble, call us on (866) 638-9355",
            });
          });
      }
      if(isValid){
      this.setState(
        {
          phoneNumber: value,
          validationError: false
        },
        () => this.checkEmailPhone()
      );}else{
        this.setState({
          phoneNumber: "",
          isvalidEmailPhone: true,
          validationError: false
        });
      }
    }
  };

  getCleanNumber = v => v.replace(/^\+1/, "").replace(/\D/g, "");
  
  setValue = (value, isValid, parentDetails) => {
    if (isValid) {
      this.setState({
        phoneNumber: value,
      });
    } else {
      this.setState({
        phoneNumber: "",
      });
    }
  };

  checkEmailPhone = () => {
    if (this.state.email && this.state.phoneNumber) {
      this.setState({
        isvalidEmailPhone: false,
      });
    }
  };

  confirmContact = () => {
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    this.setState({
      loaderShow: true,
      contactModal: false,
    });
    let phone = this.state.countryCode + this.state.phoneNumber;
    // this.getInviteStatus("sms", phone);
    this.sendAuthRequest('sms', phone);
  };
  confirmContactEmailAll = () =>{ 
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    this.setState({
      loaderShow: true,
      contactModal: false,
    });
    let phone = this.state.countryCode + this.state.phoneNumber;
    this.saveEmailPhone();
  }

  saveEmailPhone = (type) => {
    let cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM"));

    let dataObj = {
      subId: cookiesData.subID,
      email: this.state.email.toLowerCase(),
      oldEmail: this.state.oldEmail.toLowerCase(),
      phone: this.state.countryCode + this.state.phoneNumber,
    };
    console.log("--dataObj --", dataObj);

    axios
      .post(configuration.baseUrl + "/setupfamily/saveEmail", dataObj)
      .then((response) => {
        if (response.data.code === 200) {
          let CurrentLoginUser = JSON.parse(
            localStorage.getItem("CurrentLoginUser")
          );
          let obj = {
            userName: CurrentLoginUser.userName,
            id: CurrentLoginUser.id,
            email: this.state.email,
            oldEmail: this.state.oldEmail,
            phone: this.state.countryCode + this.state.phoneNumber,
          };
          localStorage.setItem("CurrentLoginUser", JSON.stringify(obj));

          this.setState({
                     validationError: false,
          });
          this.resendAuthRequest(type || "all", this.state.countryCode + this.state.phoneNumber);
          // this.goToAgentDashboard(this.state.reqType);
        } else if (response.data.code === 202) {
          this.setState({ validationError: response.data.message, loaderShow: false,  emailPhoneModal: true});
        } else if (response.data.code === 500) {
          this.setState({ validationError: response.data.message, loaderShow: false,  emailPhoneModal: true});
        }
      });
  };

  verifyEmail = (type) => {
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    if (this.state.email != this.state.oldEmail) {
      axios.get(configuration.agentURL + "/agentlogin/validateEmail/" + this.state.email)
        .then((response) => {
          console.log('res, ', response.data);
          if (response.data.code == 200) {
            this.setState({
              emailModal: false,
              loaderShow: true
            });
            console.log('200');
            this.saveEmailPhone(type);          }
          else {
            this.setState({
              loaderShow: false,
              msgModal: true,
              // errMsg: "User already registered with this Email ID!",
              errMsg : `A prospect has already been registered with this email address: ${this.state.email}`,
              refresh: true
            });
          }
        })
        .catch(error => {
          console.log(error);
          console.log(error.response);
          this.setState({
            loaderShow: false,
          });
        });
    } else {
      this.setState({
        emailModal: false,
        loaderShow: true
      });
      console.log('else');
      this.sendAuthRequest("email", CurrentLoginUser.phone);
    }
  }

  handleDateChange = (date, didMount) => {
    this.setState(
      {
        targetDate: date,
      },
      () => {
        let panel = document.getElementById("date-picker-dialog");
        panel.addEventListener("onmouseleave", function () {
          document.getElementById("date-picker-dialog-label").style.paddingTop =
            "10px";
        });
      }
    );
  };
  
  sendAuthRequest = (requestType, phoneNumber) => {
    axios
      .get(
        configuration.baseUrl +
          "/enrollment/registration/" +
          this.state.email.toLowerCase() +
          "/" +
          phoneNumber +
          "/" +
          requestType
      ) //this.props.email
      .then((response) => {
        if (response && response.data.code === 200) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              requestType === "sms"
                ? "Authorization SMS sent successfully!"
                : "Authorization mail sent successfully!",
          });
        } else if (response.data.code === 202) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg: "Authorization mail sent successfully!",
          });
        } else if (response.data.code === 204) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              requestType === "sms"
                ? "The authorization SMS was RESENT!"
                : "The authorization email was RESENT!",
          });
        } else if (response.data.code === 409) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            // popUpMsg: "User already exists in the given User Pool.",
            popUpMsg:`A user account with this email address: ${this.state.email} already exists in the Enrollment Portal. `
          });
        } else if (response.data.code === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              "There was an error in sending the authorization link. Please try again later.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
        if (error.response.status === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            popUpMsg:
              "There was an error in sending the authorization link. Please try again later.",
          });
        }
      });
  };

  resendAuthRequest = (requestType, phoneNumber) => {
    let url;
    // if(this.state.emailFlag){
    //   url = configuration.baseUrl +
    //   "/enrollment/resendAuth/" +
    //   this.state.email +
    //   "/" +
    //   phoneNumber +
    //   "/" +
    //   requestType;
    // }else
    url = configuration.baseUrl +
    "/enrollment/registration/" +
    this.state.email.toLowerCase() +
    "/" +
    phoneNumber +
    "/" +
    requestType;

    axios (url) //this.props.email
      .then((response) => {
        if (response && response.data.code === 200) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            resendAuthModal: false,
            emailFlag: true,
            popUpMsg: "Authorization mail and SMS sent successfully.",
          });
        } else if (response.data.code === 202) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            resendAuthModal: false,
            emailFlag: true,
            popUpMsg: "Authorization mail and SMS sent successfully.",
          });
        } else if (response.data.code === 204) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            resendAuthModal: false,
            emailFlag: true,
            popUpMsg:
              requestType === "sms"
                ? "Authorization mail and SMS resent successfully."
                : "Authorization mail and SMS resent successfully.",
          });
        } else if (response.data.code === 409) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            resendAuthModal: false,
            inviteStatus: "",
            emailFlag: true,
            popUpMsg:`A user account with this email address: ${this.state.email} already exists in the Enrollment Portal. `
            // popUpMsg: "User already exists in the given User Pool.",
          });
        } else if (response.data.code === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            resendAuthModal: false,
            inviteStatus: "",
            popUpMsg:
              "There was an error in sending the authorization link. Please try again later.",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
        if (error.response.status === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            popUpMsg:
              "There was an error in sending the authorization link. Please try again later.",
          });
        }
      });
  };
  handleBack = () => {
    this.setState(
      {
        paymentScreenModal: false,
      },
      () => {
        if (!this.state.fromACHFail) this.props.handlePrev();
      }
    );
  };

  handleReenrollClose = () => {
    this.handleLogout();
    window.close();
  };

  checkSubmitButtonDisabled = () => {
    if (this.state.count <= 4) {
      return true;
    } else {
      if (this.state.fullName === "") {
        return true;
      } else {
        if (this.state.signType !== "stylized") {
          if (!this.state.canvasDone) {
            return true;
          }
        }
      }
    }
    return false;
  };

  callReceipt = () => {
    fetch(
      configuration.baseUrl +
        "/setuppayment/getTransactionReceiptDetails/" +
        this.state.subID)
      .then((response) => response.json())
      .then((response) => {
        this.setState({receiptModal: !this.state.receiptModal})
        if (response.response) {
          console.log('receipt details - ', response.response);
          this.setState({receiptDetails: response.response})
        } else {
          this.setState({receiptDetails: null})
        }
      })
  }

  updatePaymentInfo = () => {
    this.setState({showPaymentModal: true, loaderShow: false})
  }

  showSendAuthOption = () => {
    this.setState({resendAuthModal: true})
  }

  render() {
    console.log(this.state.count);
    var min =this.state.minDate;
    const { classes } = this.props;
    let currentScreen = "";
    let myDate =
      moment(this.state.targetDate).format("MM") +
      "/" +
      moment(this.state.targetDate).format("DD") +
      "/" +
      moment(this.state.targetDate).format("YYYY");
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let futureTomarow = new Date(today);
    let futureDate;
    if (true ) {
      if (new Date() < new Date("05/01/2021")) {
        if (new Date() < new Date(this.state.empEffectiveDate)) {
          let efectiveDate = new Date(this.state.empEffectiveDate);
          let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
          if (effectiveDay === 1 || effectiveDay > 1) {
            tomorrow.setDate(1);
            tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);
    
            futureTomarow.setDate(1);
            futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
          }
        } else {
          tomorrow.setDate(1);
          tomorrow.setMonth(4);
          futureTomarow.setDate(1);
          futureTomarow.setMonth(4);
        }
      } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
        if (new Date() < new Date(this.state.empEffectiveDate)) {
          let efectiveDate = new Date(this.state.empEffectiveDate);
          let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
          if (effectiveDay === 1 || effectiveDay > 1) {
            tomorrow.setDate(1);
            tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);
    
            futureTomarow.setDate(1);
            futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
          }
        } else {
          tomorrow.setDate(1);
          tomorrow.setMonth(today.getMonth() + 1);
          futureTomarow.setDate(1);
          futureTomarow.setMonth(today.getMonth() + 1);
        }
      }
      futureDate = futureTomarow.setDate(futureTomarow.getDate() + 30);
    } else {
      futureDate = futureTomarow.setDate(futureTomarow.getDate() + 30);
    }
    if (this.state.count === 1) {
    
      currentScreen = (
        <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px", minHeight: "200px" }}>
          
          <Grid item xs={12} style={{ marginBottom: "5px" }} id="14">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.checkBoxSecond}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#23436c", marginLeft: -12 }}
                // onClick={this.showCheckbox5}
                onClick={() => {
                  this.setState({ checkBoxSecond: !this.state.checkBoxSecond });
                  setTimeout(() => this.getDisabled(), 100);
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                marginLeft: "30px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
                I acknowledge that I have read, understand, and agree to the  <span >
                <a style= {{color :"#037BFE", cursor: "pointer"}} onClick={() =>isMobile? window.open(JoinderAgreement) : this.setState({ProgramSummary: "Joinder Agreement"})}><u>Joinder Agreement</u></a>.
              </span>{" "}
             
          
            </Grid>
          </Grid>
          
          <Grid item xs={12} style={{ marginTop: "5px" }} id="11">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.checkBoxFirst}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#23436c", marginLeft: -12 }}
                // onClick={this.showPlansModalPrivacy}
                onClick={() => {
                  this.setState({ checkBoxFirst: !this.state.checkBoxFirst });
                  setTimeout(() => this.getDisabled(), 100);
                }}
                // this.setState({ privacyPolicy: !this.state.privacyPolicy })
                // }
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                marginLeft: "30px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              I acknowledge that I have read, understand, and agree to the
                <a style= {{color :"#037BFE", cursor: "pointer"}} onClick={() => this.setState({ProgramSummary: "Terms and Conditions"})}> <u>Terms and Conditions</u></a>.             
      
            </Grid>
          </Grid>

          {this.state.showOnlyAllstateCheckbox && (
            <Grid item xs={12} style={{ marginTop: "5px" }} id="11">
              <Grid item xs={2}>
                <Checkbox
                  checked={this.state.checkBoxAllstate}
                  inputProps={{
                    "aria-label": "secondary checkbox",
                  }}
                  style={{ color: "#23436c", marginLeft: -12 }}
                  onClick={() => {
                    this.setState({ checkBoxAllstate: !this.state.checkBoxAllstate });
                    setTimeout(() => this.getDisabled(), 100);
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginLeft: "30px",
                  marginTop: "-36px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                I acknowledge that I have read, understand, and agree to the
                  <a style= {{color :"#037BFE", cursor: "pointer"}} onClick={() => this.setState({ProgramSummary: "Allstate Terms and Conditions"})}> <u>Allstate Terms and Conditions</u></a>.
              </Grid>
            </Grid>
          )}

         {this.state.termsAndConditionLink && this.state.termsAndConditionLink[0].termsLink != null && this.state.termsAndConditionLink[0].sbcLink != null &&
         <Grid item xs={12} style={{ marginBottom: "5px" }} id="14">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.checkBoxThird}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#23436c", marginLeft: -12 }}
                // onClick={this.showCheckbox5}
                onClick={() => {
                  this.setState({ checkBoxThird: !this.state.checkBoxThird });
                  setTimeout(() => this.getDisabled(), 100);
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                marginLeft: "30px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              I acknowledge that I have read, understand, and agree to the American Collective LP, <a style= {{color :"#037BFE", cursor: "pointer"}}
              onClick={() => this.setState({ProgramSummary: "Specific Plan Document"})}><u>Specific Plan Document</u></a> and
              <a style= {{color :"#037BFE", cursor: "pointer"}}
              onClick={() => this.setState({ProgramSummary: "Summary of Benefits and Coverage Document"})}><u> Summary of Benefits and Coverage Document</u></a>.
            </Grid>
          </Grid>}
        


          
         

          <Modal
            size="lg"
            show={this.state.modalShowPrivacy}
            centered
            onHide={(event) => this.hideModalPrivacy11(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION_NETWELL.PRIVACY_TITLE")}
              </Modal.Title>
                <IconButton onClick={(event)=> this.hideModalPrivacy11(event)}>
                  <CloseIcon style={{color:"#fff"}} />
                </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                overflowX: "none",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div>
                <div style={{ paddingTop: "8px" }}>
                  I acknowledge and agree that the membership option, number of
                  dependents, effective date, monthly contributions and fees,
                  and the answers to all medical questions on the Member
                  Enrollment Request above are true and correct. All enrollment
                  fees and charitable donations are{" "}
                  <sapn style={{ fontWeight: "bold" }}>non-refundable</sapn>{" "}
                  after the submission of my Member Enrollment Request.
                </div>

                {/* <div className="text-right" style={{ marginTop: "15px" }}>
                  <CustomeButton
                    onClick={(event) => this.hideModalPrivacy(event)}
                    style={{ marginRight: "15px" }}
                  >
                    {i18n.t("BUTTON.CANCEL")}
                  </CustomeButton>
                  <CustomeButton onClick={() => this.acceptPrivacyPolicy()}>
                    {i18n.t("BUTTON.ACCEPT")}
                  </CustomeButton>
                </div> */}
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={this.state.submittedModal}
            centered
            onHide={(event) => this.setState({submittedModal: false}, () => this.closeWindow())}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION_NETWELL.PRIVACY_TITLE")}
              </Modal.Title>
              <IconButton onClick={()=> this.setState({submittedModal: false}, () => this.closeWindow())}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                overflowX: "none",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div>
                <text>Your Application is Submitted Successfully.</text>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                marginTop: "10px",
                width: "160px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => this.closeWindow()}
            >
              LOGOUT
            </NextButton>
          </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={this.state.authModalShow1}
            centered
            onHide={(event) => this.authorizeHideModal111(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION_NETWELL.SHARE_TITLE")}
              </Modal.Title>
              <IconButton onClick={(event)=> this.authorizeHideModal111(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                <u>{i18n.t("SUBMIT_APPLICATION_NETWELL.SHARE0")}</u>
              </div>

              <div style={{ paddingTop: "8px" }}>
                <ul>
                  <li>
                    {/* {i18n.t("SUBMIT_APPLICATION_NETWELL.SHARE1")} */}I
                    acknowledge that netWell is <b>not</b> insurance and that
                    netWell has &nbsp;<b>not</b> been presented to me as
                    insurance either by a netWell coordinator or by any third
                    party.
                  </li>
                  <li style={{ paddingTop: "8px" }}>
                    I acknowledge that netWell does <b>not</b> replace
                    traditional insurance and that <i>members</i> remain
                    responsible for their own <i>medical requests</i>. netWell
                    does <b>not</b> assume any legal risk or obligation, nor do
                    its <i>members</i> guarantee or promise that{" "}
                    <i>eligible medical requests</i> will be <i>shared</i> or{" "}
                    <i>funded</i> by the <i>membership.</i>
                  </li>
                </ul>
              </div>
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                <u>{i18n.t("SUBMIT_APPLICATION_NETWELL.SHARE2")}</u>
              </div>
              <div style={{ paddingTop: "8px" }}>
                <ul>
                  <li>
                    {/* {i18n.t("SUBMIT_APPLICATION_NETWELL.SHARE1")} */}I
                    acknowledge that netWell <b>is</b> a Health Care Sharing
                    Ministry (“HCSM”). HCSM <i>members</i>
                    believe in a common core of religious or ethical beliefs and{" "}
                    <i>voluntarily</i> contribute toward{" "}
                    <i>members’ eligible medical requests</i> based on those
                    beliefs.
                  </li>
                  <li style={{ paddingTop: "8px" }}>
                    I acknowledge that netWell <b>is</b> a HCSM that facilitates{" "}
                    <i>sharing of eligible medical requests</i> based on{" "}
                    <i>Member Commitment Contributions</i> and the provisions of
                    the Member Guide.
                  </li>
                </ul>
              </div>

              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.authorizeHideModal1(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptAuthorization1()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={this.state.authModalShow}
            centered
            onHide={(event) => this.authorizeHideModal22(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION_NETWELL.IMP_NOTICE")}
              </Modal.Title>
              <IconButton onClick={(event)=> this.authorizeHideModal22(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u> Member Guide:</u>
                </span>
                <ul>
                  <li style={{ padding: "8px" }}>
                    I acknowledge and agree that I have or will fully read and
                    understand the most current Member Guide. I acknowledge that
                    I have determined that this <i>membership</i> meets my
                    healthcare needs. I acknowledge that I have had the
                    opportunity to voice any questions and received satisfactory
                    answers leading up to the purchase of this plan.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that I have access to the most current Member
                    Guide online (In my Welcome Email and in my Member Portal.)
                    I acknowledge that the Member Guide is part of the{" "}
                    <i>Member Enrollment Request.</i>
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that the Member Guide outlines which of my{" "}
                    <i>medical requests</i> may or may not be{" "}
                    <i>eligible for sharing</i> but does not constitute a
                    contract and carries no promise or guarantee to <i>share</i>{" "}
                    in my <i>eligible medical requests,</i> implied or
                    otherwise.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that the provisions of the Member Guide in
                    effect on the date of service for any of my{" "}
                    <i>
                      medical requests, encompasses the rules of the health plan
                      and is the document of truth
                    </i>{" "}
                    (controlling document) even if I have been given verbal{" "}
                    <i>communications</i> that are contradictory to the document
                    of truth.
                  </li>
                </ul>
              </div>

              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u>Member Duties:</u>
                </span>
                <ul>
                  <li style={{ padding: "8px" }}>
                    It is my duty to honestly, accurately and completely answer
                    the medical questions on the
                    <i>Member Enrollment Request.</i>
                  </li>
                  <li style={{ padding: "8px" }}>
                    It is my duty to read the most current Member Guide as it is
                    subject to change or update with appropriate written notice.
                  </li>
                  <li style={{ padding: "8px" }}>
                    It is my duty to make the necessary authorizations and
                    consents for my <i>Monthly Commitment Contributions </i>and{" "}
                    <i>Monthly Membership Fees</i> to be submitted.
                  </li>
                  <li style={{ padding: "8px" }}>
                    It is my duty to request a review of any{" "}
                    <i>medical request</i> that I believe has not been processed
                    correctly and, if I am still dissatisfied after such review,
                    I will utilize the provisions in the Member Guide to make an
                    appeal.
                  </li>
                  <li style={{ padding: "8px" }}>
                    It is my duty to ensure that all <i>active members</i> under{" "}
                    <i>my membership</i> abide by the
                    <i>Statement of Religious and Ethical Beliefs,</i> as it is
                    my understanding that failure to abide by these beliefs
                    and/or this Member Acknowledgement Agreement may result in
                    the <i>cancellation</i> of my <i>membership</i> and/or my{" "}
                    <i>medical requests</i> may be processed as{" "}
                    <i>ineligible </i>
                    for <i>sharing</i> per the Member Guide.
                  </li>
                </ul>
              </div>

              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u> Monthly Commitment Contributions:</u>
                </span>
                <ul>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>Monthly Commitment Contribution</i>{" "}
                    is based on the size of my <i>membership,</i> the age of the
                    oldest <i>member,</i> my place of residence and the{" "}
                    <i>membership</i>
                    option I have chosen.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>Monthly Commitment Contribution</i>{" "}
                    changes at certain ages based on the oldest <i>member’s</i>{" "}
                    age and if I change my place of residence. It can also
                    change if
                    <i>Monthly Commitment Contributions</i> change for all
                    members and I am notified in advance.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>Monthly Commitment Contribution</i>{" "}
                    includes <i>Monthly Membership Fees</i> that are itemized on
                    my <i>Monthly Commitment Contribution Request.</i>
                  </li>
                </ul>
              </div>

              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u> Length of Membership:</u>
                </span>
                <ul>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>membership</i> can become effective
                    not less than seven (7) days after nor more than sixty (60)
                    days after my enrollment, the date to be chosen by me.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>membership</i> is <i>voluntary</i>{" "}
                    and that I may <i>cancel</i> my membership at any time as
                    provided in the Member Guide and that my cancelation request
                    must be submitted in writing to netWell no later than{" "}
                    <b>72 hours prior to the next draft date.</b>
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that my <i>membership</i> can be{" "}
                    <i>cancelled</i> by netWell if I fail to follow the
                    <i>Statement of Religious and Ethical Beliefs</i> contained
                    in this Member Acknowledgement Agreement or if I fail to
                    make my <i>Monthly Commitment Contribution.</i>
                  </li>
                </ul>
              </div>

              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u> Appeal Review and Arbitration Process:</u>
                </span>
                <ul>
                  <li style={{ padding: "8px" }}>
                    I agree that I expect to be treated with respect in my
                    dealings with netWell coordinators and that I will treat the
                    coordinators with the same respect.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I agree that I will use the <i>Appeals Review Process</i> to
                    resolve any disagreements I may have regarding any{" "}
                    <i>eligibility</i> determination or how any{" "}
                    <i>medical request</i> has been processed.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I agree that I will hold netWell, its partners, its
                    employees or directors harmless and will not file a lawsuit
                    for any reason related to my participation in the netWell
                    <i>membership.</i>
                  </li>
                  <li style={{ padding: "8px" }}>
                    I agree that in the event of an unresolved disagreement that
                    I will submit said disagreement for arbitration as outlined
                    in the Member Guide.
                  </li>
                  <li style={{ padding: "8px" }}>
                    I acknowledge that any request for arbitration will be
                    handled with either the American Arbitration Association
                    (AAA) or Institute for Christian Conciliation (ICC) at the
                    mutual agreement between myself and netWell and will be held
                    in Atlanta, GA unless an alternate city is mutually agreed
                    upon.
                  </li>
                </ul>
              </div>

              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  <u> Statement of Religious and Ethical Beliefs:</u>
                </span>
                <ol>
                  <li style={{ padding: "8px" }}>
                    We believe in the God of the Bible and the Power of Prayer.
                    <br />
                    <span style={{ color: "blue", fontSize: "12px" }}>
                      <i>
                        Philippians 4:6, <u>NIV:</u> “Do not be anxious about
                        anything, but in every situation, by prayer and
                        petition, with thanksgiving, present your requests to
                        God.”
                      </i>
                    </span>
                  </li>
                  <li style={{ padding: "8px" }}>
                    We believe it is our Duty to Love and Accept one another.
                    <br />
                    <span style={{ color: "blue", fontSize: "12px" }}>
                      <i>
                        John 13:34, <u>NIV:</u> "A new command I give you: Love
                        one another. As I have loved you, so you must love one
                        another.”
                      </i>
                    </span>
                  </li>
                  <li style={{ padding: "8px" }}>
                    We believe it is our obligation to God and our fellow
                    members to Live a healthy lifestyle which avoids habits and
                    behaviors that are harmful to the body.
                    <br />
                    <span style={{ color: "blue", fontSize: "12px" }}>
                      <i>
                        1 Corinthians 10:31, <u>NIV:</u> “So whether you eat or
                        drink or whatever you do, do it all for the glory of
                        God.”
                      </i>
                    </span>
                  </li>

                  <li style={{ padding: "8px" }}>
                    We believe it is our ethical and moral responsibility to
                    Carry each other’s Burdens.
                    <br />
                    <span style={{ color: "blue", fontSize: "12px" }}>
                      <i>
                        Galatians 6:2, <u>NIV:</u> “Carry each other’s burdens,
                        and in this way you will fulfill the law of Christ."
                      </i>
                    </span>
                  </li>
                </ol>
              </div>

              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.authorizeHideModal(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptAuthorization()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>

          {/* modal 4 */}

          <Modal
            size="lg"
            show={this.state.financeAuthModalShow}
            centered
            onHide={(event) => this.hideModalFinaceAuth11(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {/* {i18n.t("SUBMIT_APPLICATION.FINANCE_TITLE")} */}
                MEMBER CONSENT FORM
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModalFinaceAuth11(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div style={{ paddingTop: "12px" }}>
                {/* {i18n.t("SUBMIT_APPLICATION.FINANCE_BODY")} */}
                This Member Consent Form <i> (“Consent”) </i> covers your{" "}
                <i>member Account,</i> membership options, and discount or
                contracted services with netWell and its affiliates that are
                accessible, either currently or in the future, through our
                websites (through a personal computer or mobile device).
              </div>
              <ol>
                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>
                        To be an active member, you must Consent to receive all
                        your membership Communications, electronically,
                      </i>
                    </u>{" "}
                    such as your <i>Monthly Commitment Contribution</i>{" "}
                    (including single
                    <i>funding</i> or recurring <i>funding</i> authorizations
                    and notices),{" "}
                    <i>Explanation of Sharing (EOS), Privacy Policy </i>(if
                    applicable), and any amendment or other disclosures related
                    thereto (collectively referred to as <i>“Communications”</i>
                    ) electronically rather than on paper.
                    <b>
                      You agree that netWell shall electronically provide to
                      you, your Communications and information related to your{" "}
                      <i>membership.</i>
                    </b>{" "}
                    You will not receive the <i>Communications</i> in paper
                    form.
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>
                        All Communications from netWell delivered to you in
                        electronic format will be considered “in writing.”
                      </i>
                    </u>{" "}
                    You should print or download (for your records) a copy of
                    the document and any other <i>Communications</i> that are
                    important to you. netWell may always, in our sole discretion
                    or if required by law, provide you with any{" "}
                    <i>Communication</i> in paper form, even if you have chosen
                    to receive it electronically. <i>Communications</i> shall be
                    sent to the <i>key member’s</i> address that netWell has for
                    you at the time any paper <i>Communications</i> are mailed.
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>Request for Copies </i>
                    </u>
                    <br />
                    <br />
                    You may request a paper copy of a Communication at any time
                    by calling netWell at 1-866-NETWELL (638-9355) or in writing
                    to netWell at 5051 Peachtree Corners Circle, Suite 200,
                    Norcross, GA 30092. If you request a copy of a previous
                    Communications, we may charge you a reasonable service
                    charge for the delivery of paper copies of any
                    Communications provided to you electronically.
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>Withdrawal of This Consent </i>
                    </u>
                    <br />
                    <br />
                    You may withdraw this <i>Consent</i> at any time after
                    submission by calling netWell at 1-866-NETWELL (638-9355).
                    netWell coordinators are available to assist you from 9:00am
                    to 6:00 pm EST, if you withdraw your <i>Consent</i> to
                    obtain electronic <i>Communications,</i>
                    your <i>membership</i> can be <i>cancelled.</i>
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>Updating Electronic Information </i>
                    </u>
                    <br />
                    <br />
                    It is your responsibility to provide netWell with a true,
                    accurate and complete email address, contact information and
                    any other information needed to contact you electronically.
                    To update your electronic address, you may call us at
                    1-866-NETWELL (638- 9355) or update your information within
                    your secure Member Portal. You agree to promptly notify
                    netWell when you change your email or other electronic
                    address. At our option, netWell may treat your provision of
                    an invalid email address, or the subsequent malfunction of a
                    previously valid email address, as a withdrawal of your{" "}
                    <i>Consent</i> to receive electronic <i>Communications.</i>
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <u>
                      <i>System Requirements </i>
                    </u>
                    <br />
                    To receive the requested <i>Communications</i>{" "}
                    electronically, you will need the following:
                    <br />
                    <br />
                    <ol type="a">
                      <li style={{ paddingTop: "8px" }}>
                        An active email address, an internet connection, along
                        with a web-enabled device with an operating system
                        capable of supporting items 2 and 3.
                      </li>
                      <li style={{ paddingTop: "8px" }}>
                        A current version* of an Internet browser we support,
                        which may include Microsoft Internet Explorer, Firefox,
                        Safari, or Chrome.
                      </li>
                      <li style={{ paddingTop: "8px" }}>
                        Access to a printer or the ability to download
                        information to keep copies for your records. You will
                        also need a current version* of a program that
                        accurately reads and displays PDF files, such as Adobe
                        Acrobat Reader.
                      </li>
                    </ol>
                  </div>
                </li>
                {/* <li> */}
                <div style={{ paddingTop: "12px" }}>
                  *By “current version,” we mean a version of the software that
                  is currently being supported by its publisher and that we
                  support.
                </div>
                {/* </li> */}

                <div style={{ paddingTop: "12px" }}>
                  If you have any questions regarding our hardware or software
                  requirements, please contact us at 1-866-NETWELL (638-9355) or
                  via email at enrollment@netwell.com.
                </div>

                <div style={{ paddingTop: "12px" }}>
                  You affirm to <i>Consent</i> to netWell to provide electronic{" "}
                  <i>Communications</i> to you, as described above. You further
                  affirm and confirm that you have the hardware and software
                  described above, that you can receive, review, and retain
                  electronic records, and that you have provided, or will
                  provide to netWell, a current, valid email address to which
                  netWell may deliver electronic <i>Communications.</i>
                </div>

                <div style={{ paddingTop: "12px" }}>
                  As a <i>member,</i> by executing this{" "}
                  <b>
                    <i>Member Acknowledgement Agreement </i>
                  </b>
                  and{" "}
                  <b>
                    <i>Member Consent Form </i>
                  </b>
                  for netWell, I ACKNOWLEDGE, ACCEPT AND AGREE TO COMPLY WITH
                  ALL the agreements and consents contained herein these forms
                  and agree to ensure compliance with these acknowledgements on
                  behalf of myself and all members of my membership, and to live
                  by the Biblically based{" "}
                  <b>
                    <i>Statement of Religious and Ethical Beliefs</i>
                  </b>{" "}
                  as stated above.
                </div>
              </ol>

              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModalFinaceAuth(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptFinaceAuth()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={this.state.ModalShowPDF && this.state.htmlMedicalInfo}
            centered
            onHide={(event) => this.hideModal7PDF(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
              Medical Questions
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModal7PDF(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div style={{ paddingTop: "1px" }}>
              <div dangerouslySetInnerHTML={{__html:this.state.htmlMedicalInfo}}/>      
               <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal7PDF(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptModal7PDF()}>
                I agree
                </CustomeButton>
              </div>
              </div>

             
            </Modal.Body>
          </Modal>


          <Modal
            size="lg"
            show={this.state.ProgramSummary}
            centered
            onHide={(event) => this.hideModal8ProgramSummary(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
             {this.state.ProgramSummary}
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModal8ProgramSummary(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "800px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
             {this.state.ProgramSummary &&
              <div style={{ paddingTop: "12px", height:this.state.ProgramSummary === "Specific Plan Document" || this.state.ProgramSummary === "Summary of Benefits and Coverage Document"?"auto":"500px"}}>
                {this.state.ProgramSummary === "Joinder Agreement"?
                <iframe src={JoinderAgreement} width={"100%"} height={"100%"}/> :
                this.state.ProgramSummary === "Terms and Conditions" ?
                <iframe src={Terms} width={"100%"} height={"100%"}/> :
                this.state.ProgramSummary === "Allstate Terms and Conditions" ?
                <iframe src={AllstateTerms} width={"100%"} height={"100%"}/> :
                (this.state.ProgramSummary === "Specific Plan Document" || this.state.ProgramSummary === "Summary of Benefits and Coverage Document") &&
                this.state.termsAndConditionLink && (
                  <ul>
                    {this.state.termsAndConditionLink.map((value) => {
                      const isSpecific = this.state.ProgramSummary === "Specific Plan Document";
                      const linkToOpen = isSpecific ? value.termsLink : value.sbcLink;

                      //Hide this item completely if the required link does not exist
                      if (!linkToOpen) return null;

                      return (
                        <li key={value.planCode}>
                          Click here for Document{" "}
                          <a
                            style={{ color: "#037BFE", cursor: "pointer" }}
                            onClick={() => window.open(linkToOpen)}
                          >
                            <u>{value.planCode}</u>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                )
             }
               <div className="text-right" style={{ marginTop: "15px", paddingBottom: "15px"}}>
                {/* <CustomeButton
                  onClick={(event) => this.hideModal8ProgramSummary(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton> */}
                <CustomeButton onClick={() => this.acceptModal8ProgramSummary()}>
                OK
                </CustomeButton>
              </div>
              </div>}

             
            </Modal.Body>
          </Modal>

          {/* modal 6 */}

          <Modal
            size="lg"
            show={this.state.ModalShow6}
            centered
            onHide={(event) => this.hideModal6(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                Waiting Period Summary
                {/* Member Banking Agreement & Authorization to Draw on Members Billing Account */}
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModal6(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div style={{ paddingTop: "12px" }}>
                I accept and agree with all my Initial Waiting Periods.
                <div style={{ paddingTop: "12px" }}>
                  {this.state.disQualifiedData && (
                    <CommonTable
                      quoteData={this.state.disQualifiedData.data}
                      check={true}
                      headerData={this.state.disQualifiedData.header}
                      tooltip={[]}
                      quickQuote={false}
                      totalReq={false}
                    />
                  )}
                </div>
              </div>

              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal6(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptModal6()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>

          {/* modal 7 */}

          <Modal
            size="lg"
            show={this.state.ModalShow7}
            centered
            onHide={(event) => this.hideModal7(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {/* {i18n.t("SUBMIT_APPLICATION.FINANCE_TITLE")} */}
                Limited Power of Attorney
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModal7(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div style={{ paddingTop: "12px" }}>
                <b>
                  Limited Power of Attorney & Other Agreements with Respect to
                  Members HealthShare Account
                </b>
              </div>
              <ol>
                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <b>
                      <u>Purpose</u>; Appointment of netWell Healthcare as
                      Authorized Agent.
                    </b>{" "}
                    The purpose of this Healthcare Sharing Limited Power of
                    Attorney (<i>“Limited Power of Attorney”</i>) is for the
                    undersigned account holder (<i>“Member”</i>) to give Health
                    Care Sharing Ministry (“netWell”) rights to conduct business
                    related to <i>Members</i> HealthShare Account (
                    <i>“Account”</i>).
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <b>
                      <u>General Terms.</u>
                    </b>{" "}
                    <i>Member</i> acknowledges and agrees as follows:
                    <ol type="a">
                      <li>
                        <b>Duration and Cancellation.</b> netWell may exercise
                        the rights and powers granted to it under this Limited
                        Power of Attorney until it is revoked.
                      </li>

                      <li>
                        <b>Signing of Document.</b> This{" "}
                        <i>Limited Power of Attorney</i> must be dated and
                        signed by the{" "}
                        <i>Member listed as the account holder.</i>
                      </li>
                    </ol>
                  </div>
                </li>

                <li>
                  <div style={{ paddingTop: "12px" }}>
                    <b>
                      <u>Scope of Limited Power of Attorney.</u>
                    </b>{" "}
                    By signing this <i>Limited Power of Attorney, Member</i>{" "}
                    hereby authorizes netWell, including, but not limited to its
                    agents, officers and employees, to act for and on{" "}
                    <i>Member’s</i> behalf in all matters related to the Members
                    Account including, but not limited to, the following:
                    <ol type="a">
                      <li>
                        <b>Open Account.</b> <i>Member</i> hereby authorizes
                        netWell, to take all actions necessary to open or reopen
                        the Members <i>Account.</i> Member understands and
                        agrees that the <i>Account</i> shall be titled in the
                        name of the <i>Member.</i>
                      </li>

                      <li>
                        <b>
                          Transfer Funds to Other netWell <u>member</u>{" "}
                          accounts.
                        </b>{" "}
                        Member hereby authorizes netWell to initiate transfers
                        electronically, on <i>Member’s</i> behalf of{" "}
                        <i>funds</i> deposited in his or her
                        <i>Account</i> to the accounts of other netWell{" "}
                        <i>members.</i>
                      </li>

                      <li>
                        <b>
                          Transfer <i>Funds</i> to Medical Providers.
                        </b>{" "}
                        <i>Member</i> hereby authorizes netWell, to initiate
                        transfers, electronically, on <i>Member’s</i> behalf of{" "}
                        <i>funds</i> deposited in <i>Member’s Account</i> to
                        medical providers <i>medical requests.</i> This includes
                        their own eligible sharing needs, as well as on behalf
                        of other members sharing needs.
                      </li>

                      <li>
                        <b>Transfer Funds to netWell.</b> <i>Member</i> hereby
                        authorizes netWell to initiate transfers electronically,
                        on <i>Member’s</i> behalf of <i>funds</i> deposited in{" "}
                        <i>Member’s Account</i> to netWell
                      </li>

                      <li>
                        <b>
                          Transfer to and Deposit Funds in{" "}
                          <i>Member Account.</i>
                        </b>{" "}
                        <i>Member</i> hereby authorizes netWell to make deposits
                        into the Members <i>Account. </i>
                      </li>

                      <li>
                        <b>
                          Transfer <i>Funds</i> into and from the{" "}
                          <i>Member Account</i> for Other Purposes.
                        </b>{" "}
                        <i>Member</i> hereby authorizes netWell to initiate
                        transfers electronically, on <i>Member’s</i> behalf of{" "}
                        <i>funds</i> into or from the Members <i>Account</i> for
                        any other purpose authorized by the agreements between
                        <i>Member</i> and netWell.
                      </li>

                      <li>
                        <b>Close Member Account.</b> <i>Member</i> hereby
                        authorizes netWell to take all actions necessary to
                        close the Members <i>Account</i> when applicable and to
                        direct the distribution of any <i>funds </i>
                        contained therein.
                      </li>
                    </ol>
                  </div>
                </li>
                <li>
                  <b>
                    <u>Other Agreements </u>
                  </b>
                  <ol type="a">
                    <li>
                      <b>Governing Law.</b> The internal laws of the State of
                      Georgia, including its Power of Attorney Law, shall govern
                      the construction, interpretation and other matters arising
                      out of or in connection with this{" "}
                      <i>Limited Power of Attorney,</i> whether arising in
                      contract, tort, equity or otherwise, without reference to
                      any principles of conflicts of law that would apply
                      another jurisdiction’s laws.
                    </li>

                    <li>
                      <b>Ratification.</b> <i>Member</i> hereby ratifies, to the
                      extent permitted by law, all that netWell has done, shall
                      do or cause to be done related to the Members{" "}
                      <i>Account.</i>
                    </li>

                    <li>
                      <b>Legal Rights Affected.</b> THIS{" "}
                      <i>LIMITED POWER OF ATTORNEY</i> IS AN IMPORTANT LEGAL
                      DOCUMENT. BY SIGNING THIS{" "}
                      <i>LIMITED POWER OF ATTORNEY, MEMBER</i> AUTHORIZES
                      ANOTHER PERSON TO ACT FOR AND ON BEHALF OF <i>MEMBER</i>{" "}
                      AND WITHOUT FURTHER INSTRUCTION OR AUTHORITY FROM{" "}
                      <i>MEMBER. MEMBER</i>
                      SHOULD READ THIS <i>LIMITED POWER OF ATTORNEY</i>{" "}
                      CAREFULLY AND OBTAIN THE ASSISTANCE OF LEGAL COUNSEL OR
                      ANY OTHER QUALIFIED PERSON TO THE EXTENT THAT ANY
                      PROVISION OF THIS <i>LIMITED POWER OF ATTORNEY </i>IS NOT
                      FULLY UNDERSTOOD.
                    </li>
                  </ol>
                </li>
              </ol>

              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal7(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptModal7()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>

          {/* modal 8 */}

          <Modal
            size="lg"
            show={this.state.ModalShow8}
            centered
            onHide={(event) => this.hideModal8(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {/* {i18n.t("SUBMIT_APPLICATION.FINANCE_TITLE")} */}
                netWell AUTHORIZATION FOR RELEASE OF PROTECTED HEALTH
                INFORMATION
              </Modal.Title>
              <IconButton onClick={(event)=> this.hideModal8(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div style={{ paddingTop: "12px" }}>
                I understand that I have the right to revoke this authorization
                in writing unless netWell has taken any action in reliance upon
                it.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell has requested and will receive from me
                and my health care providers certain protected health
                information during my enrollment in netWell. netWell will use
                this information during and after my enrollment. I further
                understand that netWell will protect the confidentiality of that
                information in the same manner as all other protected health
                information netWell maintains and, if I do not enroll, netWell
                will not use or disclose the information netWell obtained for
                any other purpose.
              </div>

              <div style={{ paddingTop: "12px" }}>
                A doctor or health facility involved in my care may request some
                of my protected health information that netWell holds in order
                to make decisions about my care. I understand that netWell may
                make disclosures of my protected health information as necessary
                for such treatment.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell will make use and disclosure of my
                protected health information as necessary for funding purposes.
                For instance, netWell may use information regarding my medical
                procedures and treatment to process and arrange for the funding
                of medical, to determine whether services are medically
                appropriate or to otherwise pre-authorize or certify services as
                eligible to be shared under netWell’s Member Guide. netWell may
                also forward such information to another health plan that may
                also have an obligation to process and pay expenses on my
                behalf.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell will use and disclose my protected
                health information as necessary for health care operations which
                include peer review, business management, accreditation and
                licensing, utilization review and management, quality
                improvement and assurance, enrollment, voluntary disclosure of
                health conditions, compliance, auditing, and other functions
                related to my healthcare management. netWell may also disclose
                my protected health information to another health care facility,
                health care professional or health plan for such things as
                quality assurance and case management, but only if that
                facility, professional, or plan also has, or had, a patient
                relationship with me.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell may from time to time disclose my
                protected health information to my spouse, children, or others
                who are involved in my care or in payment for my care in order
                to facilitate that person’s involvement in caring for me or
                paying for my care. If I am unavailable, incapacitated, or
                facing an emergency medical situation and netWell determines
                that a limited disclosure may be in my best interest, netWell
                may share limited protected health information with such
                individuals without my approval. netWell may also disclose
                limited protected health information to a public or protected
                entity that is authorized to assist in disaster relief efforts
                in order for that entity to locate a family member or other
                persons that may be involved in some aspect of caring for me.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that certain aspects and components of netWell
                services are performed through contracts with outside persons or
                organizations, such as legal services, bank services, medical
                discount organizations, pharmacy managers, etc. At times it may
                be necessary for netWell to provide some of my protected health
                information to one or more of these outside persons or
                organizations who assist with health care operations. In all
                cases, netWell requires these business associates to
                appropriately safeguard the privacy of my information.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell may communicate with me regarding my
                medical requests, Monthly Commitment Contribution, or other
                matters related to my health. If I am concerned that the
                information being sent to me may be viewed by another person, I
                understand that reasonable requests to receive communications
                regarding my protected health information by alternative means
                or at alternative locations will be accommodated by netWell.
              </div>

              <div style={{ paddingTop: "12px" }}>
                I understand that netWell may, from time to time, use my
                protected health information to determine whether I might be
                interested in or benefit from treatment alternatives or other
                health-related programs, products or services which may be
                available to me as a member. netWell may use my protected health
                information to identify whether I have a particular illness, and
                contact me to advise me that, as a member, a disease management
                and/or wellness program may help me manage my illness or health
                condition.
              </div>

              <div style={{ paddingTop: "12px" }}></div>

              <div style={{ paddingTop: "12px" }}></div>

              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal8(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptModal8()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={this.state.authModalShow4}
            centered
            onHide={(event) => this.hideModal4Privacy11(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>Sharing Vs Insurance</Modal.Title>
              <IconButton onClick={(event)=> this.hideModal4Privacy11(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {this.state.loaderShow ? <Loader></Loader> : ""}
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.TITLE")}
              </div>
              <div style={{}}>
                <div style={{ paddingTop: "12px", fontWeight: "bold" }}>
                  {i18n.t("MODAL_POPUP2.QUESTION1")}
                </div>
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER1")}
              </div>

              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.QUESTION2")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER2")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                <ol>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER21")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER22")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER23")}
                  </li>
                  <li> {i18n.t("MODAL_POPUP2.ANSWER24")}</li>
                </ol>
              </div>
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.QUESTION3")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER3")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER31")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER32")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER33")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.QUESTION4")}
              </div>

              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER4")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER41")}
                <a
                  href="https://www.netwell.com/faqs/"
                  target="_blank"
                  rel="noopener"
                  style={{
                    color: "#23436c",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {i18n.t("MODAL_POPUP2.READ")}
                </a>
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.QUESTION5")}
              </div>

              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER5")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER51")}
                <span>
                  <a
                    href="http://www.netwell.com/wp-content/uploads/2020/02/UHS-State-Legal-Notices-UHS-SLN-22820.pdf"
                    target="_blank"
                    rel="noopener"
                    style={{
                      color: "#23436c",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {i18n.t("MODAL_POPUP2.ANSWER52")}
                  </a>
                </span>
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER53")}
                <span>
                  <a
                    href="http://www.netwell.com/wp-content/uploads/2020/02/UHS-State-Mandate-Penalties-Disclaimer-UHS-SMPD-22820.pdf"
                    target="_blank"
                    rel="noopener"
                    style={{
                      color: "#23436c",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {i18n.t("MODAL_POPUP2.ANSWER52")}
                  </a>
                </span>
              </div>
              {/* <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal4Privacy(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptPrivacyPolicy4()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div> */}
            </Modal.Body>
          </Modal>
        </Grid>
      );
    } else if (this.state.count === 2) {
      currentScreen = <div></div>;
    } else if (this.state.count === 3) {
      currentScreen = (
        // <>
        <div>
          <Grid item xs={12}>
            <Grid item xs={12} style={{ marginLeft: "16px" }}>
              <Typography
                variant="h6"
                component="h3"
                style={customeClasses.questionTitleText}
              >
                {i18n.t("SUBMIT_APPLICATION.TERMS")}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "10px", marginBottom: "5px" }}
            >
              <Grid item xs={2}>
                <Checkbox
                  checked={this.state.healthTerms}
                  inputProps={{
                    "aria-label": "secondary checkbox",
                  }}
                  style={{
                    color: "#23436c",
                    cursor: "pointer",
                    marginLeft: -12,
                  }}
                  onClick={this.showPlansModalHealth}
                ></Checkbox>
                {/* } */}
              </Grid>
              <Grid
                item
                xs={12}
                onClick={this.showFinanceAuthModal}
                style={{
                  cursor: "pointer",
                  lineHeight: "19px",
                  display: "flex",
                }}
                // onClick={this.showPlansModalHealth}
              >
                <div
                  style={{
                    marginLeft: "25px",
                    marginTop: "-33px",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      lineHeight: "19px",
                      cursor: "pointer",
                      textAlign: "justify",
                      fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                    }}
                    onClick={this.showPlansModalHealth}
                  ></span>
                  {i18n.t("SUBMIT_APPLICATION.TEXT4")}
                  <span
                    style={customeClasses.hyperTextScreen3}
                    onClick={this.showPlansModalHealth}
                  >
                    {i18n.t("SUBMIT_APPLICATION.TEXT5")}
                  </span>
                  {/* </span> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            size="lg"
            show={this.state.modalShow}
            centered
            onHide={(event) => this.viewPlanHideModalHealth1(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.MODEL_TITLE")}
              </Modal.Title>
              <IconButton onClick={(event)=> this.viewPlanHideModalHealth1(event)}>
                <CloseIcon style={{color:"#fff"}} />
              </IconButton>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_LAST.QUESTION_LAST")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                <ol style={{ marginLeft: "-25px" }}>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER1_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER2_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER3_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER4_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER5_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER6_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER7_LAST")}
                  </li>
                </ol>
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.viewPlanHideModalHealth11(event)}
                  style={{ marginRight: "15px" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.viewPlanHideModalHealth()}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (this.state.count === 4) {
      currentScreen = (
        <div>
          <Grid container spacing={4} justify="space-between">
            <Grid item xs={12} sm={5}>
              <Typography
                variant="h6"
                component="h3"
                style={customeClasses.questionTitleText}
              >
                Authorization for enrollment
              </Typography>

              <Grid
              item
              xs={12}
              sm={12}
              style={{
                textAlign: "justify",
                marginTop: "25px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
            >
              <span>
                By authorizing this application you agree that you have
                understood and accepted all terms and policies that have been
                explained to you by your Health Representative.{" "}
              </span>
            </Grid>
              <div style={{marginTop: 20}}>
              <Sample
                setChild={this.nameChangeHandler.bind(this)}
                name={"FirstName"}
                isValidFullName={this.state.isValidFullName}
                reqFlag={true}
                rows={2}
                // multiline
                label={"Authorize this application by typing in your full name"}
                value={this.state.fullName}
                disable={false}
                style={customeClasses.textField}
                length={120}
                fieldType={"holderName"}
                errMsg={"Enter valid full name"}
                // helperMsg={
                //   "By typing my name above, I understand and agree that this form of electronic signature has the same legal force and affect as a manual signature."
                // }
                parentDetails={{}}
              ></Sample>
              </div>
       
            </Grid>
            <Grid
              item
              xs={12}
              sm={5}
              style={{
                textAlign: "justify",
                marginTop: "26px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
            >
                  <div>
                <Typography
                  variant="h6"
                  component="h3"
                  style={customeClasses.questionTitleText}
                >
                  e-signature
                </Typography>
                <RadioGroup
                  row
                  aria-label="option"
                  name="row-radio-buttons-group"
                  value={this.state.signType}
                  onChange={(event, value) => {
                    this.changeSignType(event, value);
                    this.setState({
                      canvasChanged: false,
                      canvasDone: false,
                    });
                  }}
                >
                  <FormControlLabel
                    value="stylized"
                    control={<PurpleRadio />}
                    label="Use stylized script"
                  />
                  <FormControlLabel
                    value="scribble"
                    control={<PurpleRadio />}
                    label="Let me draw"
                  />
                </RadioGroup>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "block",
                }}
              >
                {this.state.signType === "stylized" ? (
                  <>
                    <div id="txtsign" style={{ width: "100%", height: "100%" }}>
                      <TextSignature
                        id="textSignature"
                        text={this.state.fullName}
                        fontSize={50}
                      />
                    </div>
                  </>
                ) : (
                  <SignScroll
                    ref={this.child}
                    onCanvasChange={() =>
                      this.setState({
                        canvasChanged: true,
                      })
                    }
                    onCanvasClear={() =>
                      this.setState({
                        canvasChanged: false,
                      })
                    }
                  />
                )}
              </div>
              {this.state.signType !== "stylized" ? (
                <div>
                  <CustomeButton
                    variant="contained"
                    style={customeClasses.viewProgSum}
                    onClick={() => {
                      this.handleSignClear();
                      this.setState({ canvasChanged: false });
                    }}
                    disabled={this.state.canvasChanged ? false : true}
                  >
                    CLEAR
                  </CustomeButton>

                  <CustomeButton
                    variant="contained"
                    style={customeClasses.viewProgSum}
                    onClick={() => this.handleSignDone()}
                    disabled={this.state.canvasChanged ? false : true}
                  >
                    DONE
                  </CustomeButton>
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}></Grid>
          </Grid>
        </div>
      );
    }

    return (
      <div style={customeClasses.root}>
        {this.state.loaderShow ? <Loader></Loader> : ""}

        {this.state.count < 5 && (
          <Grid
            id="grid_div"
            container
            spacing={1}
            style={
              this.props.isAgent
                ? this.state.fromMember
                  ? customeClasses.pt_auto
                  : customeClasses.pt_none
                : customeClasses.pt_auto
            }
          >
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography component="p" style={customeClasses.rowText}>
                  {this.props.reEnroll
                    ? i18n.t("SUBMIT_APPLICATION.ReEnrollText3")
                    : i18n.t("SUBMIT_APPLICATION.TEXT3")}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  classes={{
                    colorPrimary: classes.colorPrimary,
                    barColorPrimary: classes.barColorPrimary,
                  }}
                  style={classes.progress}
                  value={this.state.progress}
                />
              </Grid>
              <Grid item xs={12} style={{}}>
                {currentScreen}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={7} md={7} lg={7}>
              {/*style={{marginTop:'30px'}}*/}
              <WizardButton
                variant="contained"
                style={customeClasses.button}
                disabled={this.state.count === 1}
                onClick={this.reduceProgress}
              >
                {i18n.t("BUTTON.BACK")}
              </WizardButton>
            {this.state.count !== 4 &&  <WizardButton
                variant="contained"
                style={customeClasses.button}
                disabled={this.state.nextDisabled} /*&& this.state.healthTerms*/
                onClick={this.increaseProgress}
              >
                {i18n.t("BUTTON.NEXT")}
              </WizardButton>}

              {this.state.count === 4 && (
        
                <ViewQuoteButton
  
                  variant="outlined"
                  style={customeClasses.viewProgSum}
                  onClick={() => this.setState({ planSelectionModal: true, viewProgramSummary: true })}
                >
                  VIEW PROGRAM SUMMARY
                </ViewQuoteButton>

            )}
              <FinishButton
                variant="contained"
                style={customeClasses.finishButton}
                disabled={
                  (this.state.count <= 4 && this.state.fullName === "") ||
                  (this.state.signType === "scribble" && !this.state.canvasDone)
                }
                onClick={() => this.verifyAddress()}
              >
                {i18n.t("BUTTON.SUBMITAPPLICATION")}
              </FinishButton>
            </Grid>

          

            <Modal
              size="md"
              show={this.state.successModal}
              centered
              onHide={() => this.handlenClose}
            >
              <Modal.Header style={customStyle.modal_header}>
                <Modal.Title>
                  {i18n.t("SUBMIT_APPLICATION.MODEL_TITLE2")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div
                  style={{
                    textAlign: "center",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  <p>{this.state.popUpMsg}</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <CustomeButton onClick={() => this.handleClose()}>
                  {i18n.t("BUTTON.OK")}
                </CustomeButton>
              </Modal.Footer>
            </Modal>
          </Grid>
        )}
        {this.state.count === 5 &&
        (this.state.isEnrolled || this.state.isSaved || this.state.enrollFlag && this.state.fromMember == false || this.state.fromMember == null || this.state.isAdmin) ? (
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {this.props.reEnroll
                  ? i18n.t("SUBMIT_APPLICATION.MESSAGE_REENROLL")
                  : i18n.t("SUBMIT_APPLICATION.MESSAGE")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("SUBMIT_APPLICATION.MSG_2")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <FinishButton
                variant="contained"
                style={{ width: "115px", height: "40px" }}
                onClick={() => this.handleLogout()}
              >
                LOGOUT
              </FinishButton>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        {this.state.count === 6 &&
        (this.state.fromMember == true || this.state.fromLogin) ? (
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {this.props.reEnroll
                  ? i18n.t("SUBMIT_APPLICATION.MESSAGE_REENROLL")
                  : i18n.t("SUBMIT_APPLICATION.MESSAGE")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("SUBMIT_APPLICATION.MSG_2")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <FinishButton
                variant="contained"
                style={{ width: "115px", height: "40px" }}
                onClick={() =>
                  this.state.fromLogin
                    ? this.handleLogout()
                    : this.handleReenrollClose()
                }
              >
                {this.state.fromLogin ? "LOGOUT" : "CLOSE"}
              </FinishButton>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        <Modal
          size="md"
          show={this.state.paymentScreenModal}
          onHide={(event) =>
            this.setState({ paymentScreenModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>You’re done!</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            {/*The authorizations need to be done by the prospect. Hence please exit the enrollment wizard to return to your agent dashboard. On the actions menu of the prospect, click 'Send sign-up email' to invite them to complete the process.*/}
            {/*The final authorization must be completed by the prospect. Click the button below to send the authorization request email to the prospect. The prospect will need to click on the link in the email to access this page where they will see a program summary. If acceptable, the prospect will be prompted to type in their full name and click on SUBMIT APPLICATION to authorize this enrollment.*/}
            This final step must be completed by the prospect. Click the button
            below to send the authorization request email to the prospect. The
            prospect will need to click on the link in the email to access this
            step. They will first review a summary of the program and accept the
            terms and policies. To authorize this enrollment the prospect will
            be prompted to type in their full name and click on SUBMIT
            APPLICATION.<br />{""}<br />
            {
              this.state.achSelected &&
              <b>ACH Debit requires mandatory verification of either the email address or the phone number. Please ensure the correct email address and phone number to avoid verification errors.</b>
            }
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                // marginTop: "10px",
                marginRight: "10px",
                width: "120px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              onClick={() => this.handleBack()}
            >
              BACK
            </NextButton>{" "}
            <NextButton
              style={{
                // marginTop: "10px",
                width: "auto",
                height: "40px",
                marginRight: "10px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              onClick={() => this.showSendAuthOption()}
            >
              {"SEND AUTH EMAIL & TEXT"}
            </NextButton>
            {/* <NextButton
              style={{
                width: "150px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              // disabled={true}
              // disabled={this.props.reEnroll}
              onClick={() => this.getEmailPhoneDetails("sms")}
            >
              SEND AUTH TEXT
            </NextButton> */}
          </Modal.Footer>
        </Modal>



       {(this.state.statusModal) && 
       <StatusPopup 
            gotoBack={() => this.props.jumptopayment()} 
            sendAuthResendAuth={() => this.showSendAuthOption()}
            callReceiptModal={() => this.callReceipt()}
            saveApplication={() => this.saveApplication(true)}
            payflag={this.state.payflag}
            sourceid={this.state.sourceid && this.state.sourceid}
            updatePaymentInfo={() => this.updatePaymentInfo()}
            reEnrollBySC={this.props.reEnrollBySC}
            />}

        <AlertModal showAlert={this.state.alertValue} toggleAlert={this.toggleAlert} alertMsg={this.state.alertMessage} />
        {
          this.state.showPaymentModal &&
          <ChangePayment open={this.state.showPaymentModal} subId={this.state.subID} source={this.state.sourceid} memberData={this.row} closeModal={() => this.setState({showPaymentModal: false})} toggleLoader={(v) => this.setState({loaderShow: v})} toggleAlertBox={this.toggleAlertBox} />
        }

        <Modal
          size="xl"
          show={this.state.receiptModal}
          onHide={(event) =>
            this.setState({ receiptModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Receipt</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
              maxHeight: '65vh',
              overflowY: 'auto'
            }}
          >
            <div>
              {this.state.receiptDetails ?
                <Receipt receiptDetails={this.state.receiptDetails} />
                :
                this.state.achSelected &&
                <text>The ACH Debit is pending. It will take 4-5 days for the receipt to be generated. Please try again later.</text>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <NextButton
              style={{
                marginLeft: "10px",
                width: "auto",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              onClick={() => {
                this.setState({ receiptModal: false, loaderShow: false });
              }}
            >
              CLOSE
            </NextButton>
          </Modal.Footer>
        </Modal>

       <Modal
          size="md"
          show={this.state.resendAuthModal}
          onHide={(event) =>
            this.setState({ resendAuthModal: false, loaderShow: false, validationError: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} sm={12} md={6} lg={12}>
                <p>Please verify and confirm the prospect's details.</p>
                
                  <Sample
                    setChild={this.setUserValue.bind(this)}
                    reqFlag={true}
                    name={"email"}
                    label={"Email ID"}
                    value={this.state.email}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={50}
                    fieldType={"email"}
                    errMsg={"Enter valid email Id"}
                    helperMsg={"Email is required"}
                    parentDetails={{ name: "email" }}
                  ></Sample>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <Sample
                    setChild={this.setUserValue.bind(this)}
                    reqFlag={true}
                    name={"phone"}
                    label={"Mobile No."}
                    value={this.state.phoneNumber}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={10}
                    fieldType={"phone"}
                    errMsg={"Enter valid mobile no."}
                    helperMsg={"Mobile no. required"}
                    parentDetails={{ name: "phone" }}
                  ></Sample>
                </Grid>
              </Grid>
            </div>
            {this.state.validationError ? (
              <div
                style={{
                  color: "#f30",
                  fontSize: "12px",
                  textAlign: "left",
                  padding: "10px 0",
                }}
              >
             {this.state.validationError}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                width: "auto",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              disabled={(this.state.email && this.state.phoneNumber && !this.state.validationError) ? false : true}
              onClick={() => this.setState({resendAuthModal: false,}, () =>{
                this.confirmContactEmailAll()
              })} >
             SEND AUTH
            </NextButton>
            <NextButton
              style={{
                marginLeft: "10px",
                width: "auto",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              onClick={() => {
                this.setState({ resendAuthModal: false, loaderShow: false, validationError: false }, ()=>{
                  this.getContactEmailDetails()
                });
              }}
            >
              CANCEL
            </NextButton>
          </Modal.Footer>
        </Modal>


        <Modal
          size="md"
          show={this.state.emailPhoneModal}
          onHide={(event) =>
            this.setState({ emailPhoneModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} sm={12} md={12}>
                  Please add prospect email and contact number.
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <Sample
                    setChild={this.setUserValue.bind(this)}
                    reqFlag={true}
                    name={"email"}
                    label={"Email ID"}
                    value={this.state.email}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={50}
                    fieldType={"email"}
                    errMsg={"Enter valid email Id"}
                    helperMsg={"Email is required"}
                    parentDetails={{ name: "email" }}
                  ></Sample>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <Sample
                    setChild={this.setUserValue.bind(this)}
                    reqFlag={true}
                    name={"phone"}
                    label={"Mobile No."}
                    value={this.state.phoneNumber}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={10}
                    fieldType={"phone"}
                    errMsg={"Enter valid mobile no."}
                    helperMsg={"Mobile no. required"}
                    parentDetails={{ name: "phone" }}
                  ></Sample>
                </Grid>
              </Grid>
            </div>
            {this.state.validationError ? (
              <div
                style={{
                  color: "#f30",
                  fontSize: "12px",
                  textAlign: "left",
                  padding: "10px 0",
                }}
              >
                {" "}
                {this.state.validationError} 
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                width: "150px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              disabled={this.state.isvalidEmailPhone ? true : false}
              onClick={() => this.saveEmailPhone()}
            >
              SAVE
            </NextButton>
            <NextButton
              style={{
                marginLeft: "10px",
                width: "150px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginBottom: "10px"
              }}
              onClick={() => {
                this.setState({ emailPhoneModal: false, loaderShow: false, validationError: false });
              }}
            >
              CANCEL
            </NextButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.contactModal}
          onHide={(event) =>
            this.setState({ contactModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} sm={12} md={11}>
                  Please verify and confirm the prospect's phone number.
                </Grid>
                <Grid item xs={12} sm={12} md={11}>
                  <Sample
                    setChild={this.setValue.bind(this)}
                    reqFlag={true}
                    name={"phone"}
                    label={"Mobile No."}
                    value={this.state.phoneNumber}
                    disable={false}
                    style={customStyle.textField}
                    length={10}
                    fieldType={"phone"}
                    errMsg={"Enter valid mobile no."}
                    helperMsg={"Mobile no. required"}
                    parentDetails={{}}
                  ></Sample>
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                marginTop: "10px",
                width: "160px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              disabled={this.state.phoneNumber === ""}
              onClick={() => this.confirmContact()}
            >
              SEND AUTH TEXT
            </NextButton>
            <NextButton
              style={{
                marginLeft: "10px",
                width: "150px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
                marginTop: "10px",
              }}
              onClick={() => {
                this.setState({
                  contactModal: false,
                  paymentScreenModal: true,
                  phoneNumber: "",
                });
              }}
            >
              CANCEL
            </NextButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.emailModal}
          onHide={(event) =>
            this.setState({ emailModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} sm={12} md={11}>
                  Please verify and confirm the prospect's email address.
                </Grid>
                <Grid item xs={12} sm={12} md={11}>
                  <Sample
                    setChild={this.setUserValue.bind(this)}
                    reqFlag={true}
                    name={"email"}
                    label={"Email ID"}
                    value={this.state.email}
                    disable={this.props.reEnroll}
                    style={customStyle.textFieldWrp}
                    length={50}
                    fieldType={"email"}
                    errMsg={"Enter valid email Id"}
                    helperMsg={"Email is required"}
                    parentDetails={{ name: "email" }}
                  ></Sample>
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <NextButton
              style={{
                width: "160px",
                marginTop: 10,
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              disabled={this.state.email === ""}
              onClick={() => this.verifyEmail('email')}
            >
              SEND AUTH EMAIL
            </NextButton>
            <NextButton
              style={{
                marginLeft: "10px",
                marginTop: 10,
                width: "150px",
                height: "40px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => {
                this.setState({
                  emailModal: false,
                  loaderShow: false
                });
              }}
            >
              CANCEL
            </NextButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xl"
          show={this.state.planSelectionModal}
          onHide={(event) =>
            this.setState({ planSelectionModal: false, loaderShow: false, viewProgramSummary: false })
          }
          backdrop="static"
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Program Summary</Modal.Title>
            <IconButton onClick={()=> this.setState({ planSelectionModal: false, loaderShow: false, viewProgramSummary: false })}>
              <CloseIcon style={{color:"#fff"}} />
            </IconButton>
          </Modal.Header>
          <Modal.Body>
            {this.state.loaderShow ? <Loader></Loader> : ""}
            <div style={customeClasses.root}>
              <Grid container style={{ marginTop: "1%" }}>
                <Grid item xs={12} sm={12}>
                {!this.state.viewProgramSummary && <span>I agree that I have full and complete understanding of the programs for which I am electing and I am the applicant. I accept the following:</span>}
                  <div
                    className="addOnTable reviewChoice popupTable"
                    style={{ overflowX: "auto", paddingTop:10 }}
                  >
                    {this.state.tableData && (
                      <CommonTable
                        quoteData={this.state.tableData.body}
                        check={true}
                        headerData={this.state.tableData.header}
                        tooltip={[]}
                        quickQuote={false}
                        totalReq={true}
                      />
                    )}
                  </div>
                  {this.props.clientId == "1004" ||
                  this.props.clientId == 1004 ||
                  this.props.clientId == "1005" ||
                  this.props.clientId == 1005 ||
                  this.props.clientId == "1006" ||
                  this.props.clientId == 1006 ||
                  this.props.clientId == "1007" ||
                  this.props.clientId == 1007 ? null : (
                    <p
                      style={{
                        fontSize: "11px",
                        fontWeight: "bold",
                        paddingTop: "10px",
                      }}
                    >
                      {/* *The total amount will include a 0% charge for the use of
                      a credit card as your payment method. To avoid the charge,
                      please use ACH as your payment method in the screen that
                      follows. */}
                    </p>
                  )
                  }
                </Grid>
                {/* <Grid item xs={12} sm={7}>
                  <CustomeButton
                    style={{ height: "40px" }}
                    onClick={() =>
                      this.setState({ FamilyDetailsMoreInfoModal: true })
                    }
                  >
                    REVIEW FAMILY DETAILS
                  </CustomeButton>
                </Grid> */}
              </Grid>
            </div>
            <div></div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              style={{ height: "40px" }}
              onClick={() =>
                this.setState({
                  planSelectionModal: false,
                  loaderShow: false,
                  FamilyDetailsMoreInfoModal: false,
                  viewProgramSummary: false
                }, () => this.checkACH())
              }
            >
             {this.state.viewProgramSummary? "OK" : "I accept"}
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xl"
          show={this.state.FamilyDetailsMoreInfoModal}
          onHide={() =>
            this.setState({
              FamilyDetailsMoreInfoModal: false,
              planSelectionModal: true,
            })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title style={{ color: "black" }}>Family Details</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              padding: "40px 20px",
              fontSize: "14px",
              textAlign: "justify",
            }}
          >
            <div>
              <div
                className={
                  this.props.reEnroll
                    ? "reEnrollTable familyDetailsTable reivewTable"
                    : "reivewTable familyDetailsTable"
                }
                style={{ overflowX: "auto" }}
              >
                {this.state.popTable && (
                  <CommonTable
                    quoteData={this.state.popTable.body}
                    check={true}
                    headerData={this.state.popTable.header}
                    tooltip={[]}
                    quickQuote={false}
                    totalReq={true}
                    reEnroll={this.props.reEnroll}
                  />
                )}
              </div>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ background: "#f1f1f1" }}>
            <ViewButton
              onClick={() =>
                this.setState({ FamilyDetailsMoreInfoModal: false })
              }
            >
              Done
            </ViewButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xs"
          show={this.state.targetDateModal}
          onHide={(event) =>
            this.setState({ targetDateModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Message</Modal.Title>
            <IconButton onClick={()=> this.setState({ targetDateModal: false, loaderShow: false })}>
              <CloseIcon style={{color:"#fff"}} />
            </IconButton>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "14px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  The Program Effective Date you selected is no longer valid.
                  Please select a new date when you'd prefer the benefit to
                  begin.
                </Grid>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      required
                      onBlur={() => this.setState({ birthDtFocus: true })}
                      onMouseOver={() => this.setState({ birthDt: true })}
                      onMouseLeave={() => this.setState({ birthDt: false })}
                      autoComplete="off"
                      margin="none"
                      id="date-picker-dialog"
                      label="Select Program Effective Date"
                      format="MM/dd/yyyy"
                      error={this.state.dateErr} //&&!this.state.todayDateValid
                      helperText={this.state.dateErr ? "Enter valid date" : ""} //this.state.todayDateValid?'Date Required':
                      value={this.state.targetDate} //this.state.todayDateValid?null:
                      onFocus={(e) => e.target.blur()}
                      onCopy={this.handlerCopy}
                      onPaste={this.handlerCopy}
                      inputProps={{
                        style: {
                          fontSize: "18px",
                          fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                          paddingLeft: "11px",
                          paddingRight: "10px",
                          marginTop: "11px",
                          "&:focus": { outline: "none" },
                          color: !this.state.birthDt ? "grey" : "#23436c",
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          paddingLeft: 10,
                          paddingRight: 10,
                          paddingTop: 12,
                          color: !this.state.birthDtFocus
                            ? "grey"
                            : this.state.birthDt
                            ? "#23436c"
                            : "grey",
                        },
                      }} //|| !this.state.todayDateValid
                      onChange={this.handleDateChange.bind(this)}
                      variant="filled"
                      // onMouseEnter={this.handleHover}
                      TextFieldComponent={CssTextField}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "100%" }}
                            minDate={moment().add(1, 'days')}
                            maxDate={moment().add(30, 'days')}
                    />
                    <span id="bd" style={customStyle.EnrollNew2Span}></span>
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ alignItems: "right" }}>
            <CustomeButton
              disabled={moment(moment()).isAfter(this.state.targetDate)}
              style={{ marginTop: "10px", width: "50px", height: "40px" }}
              onClick={(e) => this.handleUpdateEffectdate(e)}
            >
              Done
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.inviteStatusModal}
          centered
          onHide={() => this.closeInviteStatusModal}
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <p>
                Authorization link was already sent on {this.state.inviteStatus}
                . If you proceed to resend link, the prospect will not be able
                to sign-up with any previously sent links.
              </p>
              <p>Are you sure you want to proceed? </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              onClick={() =>
                this.sendAuthRequest(this.state.reqType, this.state.phoneNumber)
              }
            >
              YES
            </CustomeButton>
            <CustomeButton
              style={{ marginLeft: "10px" }}
              onClick={() => this.closeInviteStatusModal()}
            >
              NO
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        {/*------ Draft Day Modal ------*/}

        <Modal
          size="lg"
          show={this.state.draftDayModal}
          onHide={() => this.handleDraftModalClose()}
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Choose When You Want to be Charged</Modal.Title>
            <IconButton onClick={()=> this.handleDraftModalClose()}>
              <CloseIcon style={{color:"#fff"}} />
            </IconButton>
          </Modal.Header>
          <Modal.Body
            style={{
              minHeight: "430px",
              overflowY: "auto",
              textAlign: "justify",
              wordSpacing: "2px",
            }}
          >
            {this.state.loaderShow ? <Loader></Loader> : ""}
            <p
              style={{
                textAlign: "left",
                fontSize: "15px",
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              }}
            >
              To make it easier for you to plan your cash flow, you can decide
              when your monthly payment is processed. Please select how many
              days before payment due date, you would like your account to be
              charged.
            </p>

            <div>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="days"
                  name="row-radio-buttons-group"
                  value={this.state.draftDaySelected}
                  onChange={(event) =>
                    this.answerChangeHandler(event, "radio", "")
                  }
                >
                  <FormControlLabel
                    value="5"
                    control={<PurpleRadio />}
                    label="5 days"
                  />
                  <FormControlLabel
                    value="7"
                    control={<PurpleRadio />}
                    label="7 days"
                  />
                  {/* <FormControlLabel
                    value="10"
                    control={<PurpleRadio />}
                    label="10 days"
                  />
                  <FormControlLabel
                    value="15"
                    control={<PurpleRadio />}
                    label="15 days"
                  /> */}
                </RadioGroup>
              </FormControl>
            </div>

            <div style={{ padding: "15px 0 0 0" }}>
              {this.state.draftDaySelected ? (
                <div>
                  <div className="row effectiveDateSection">
                    <div className="col-5">Program Effective Date</div>
                    <div className="col-2"></div>
                    <div className="col-5">
                      {this.state.effectivePaymentDate}
                    </div>
                  </div>

                  <div className="paymentDatesWrapper">
                    <h5>Key Payment Dates</h5>

                    <div className="row detailsTable detailsTableHeader">
                      <div className="col-4 col-md-5 detailsTableRow">
                        Description
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        Amount
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">Date</div>
                    </div>

                    <div className="row detailsTable">
                      <div className="col-4 col-md-5 detailsTableRow">
                        Application Fee
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        {this.state.initialApplicationFee}
                        {this.state.creditCard ? <span>&#42;</span> : null}
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">
                        {this.state.todayDate}
                      </div>
                    </div>

                    <div className="row detailsTable">
                      <div className="col-4 col-md-5 detailsTableRow">
                        First Payment
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        ${this.state.firstPaymentAmount}
                        {this.state.creditCard ? <span>&#42;</span> : null}
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">
                        {this.state.firstPaymentDate}
                      </div>
                    </div>

                    <div className="row detailsTable">
                      <div className="col-4 col-md-5 detailsTableRow">
                        Recurring Monthly Payments
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        ${this.state.firstPaymentAmount}
                        {this.state.creditCard ? <span>&#42;</span> : null}
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">
                        {this.state.subsequentPaymentDate}
                        <sup>+</sup>
                      </div>
                    </div>

                    <div style={{ padding: "5px 10px" }}>
                      {this.state.creditCard ? (
                        <h6>
                          {/* <span>&#42;</span>0% merchant fees apply on credit
                          card payments */}
                        </h6>
                      ) : null}
                      <h6>
                        <span>
                          <sup>+</sup>
                        </span>
                        The actual date may change based on the number of days
                        in the month
                      </h6>
                      <h6>
                        <span>
                          <sup>+</sup>
                        </span>
                        The Application Fee is zero, if waived
                      </h6>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              onClick={() => this.handleDraftModalClose()}
              style={customStyle.m10}
            >
              {i18n.t("BUTTON.CANCEL")}
            </CustomeButton>
            <CustomeButton
              disabled={this.state.firstPaymentDate ? false : true}
              onClick={this.submitDraftDay}
              style={customStyle.m10}
            >
              Submit
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal size="md" show={this.state.msgModal} onHide={(event) => this.setState({ msgModal: false, loaderShow: false })} backdrop='static' centered>
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Message</Modal.Title>
            <IconButton onClick={()=> this.setState({ msgModal: false, loaderShow: false })}>
              <CloseIcon style={{color:"#fff"}} />
            </IconButton>
          </Modal.Header>
          <Modal.Body style={{ padding: '15px', height: '132px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <div style={customStyle.HomeContainer}>
              <div style={customStyle.HomeMAinChild}>
                {this.state.errMsg}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton style={{ height: '40px' }} onClick={() => this.setState({ msgModal: false, loaderShow: false })}>OKAY</CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          show={this.state.addressModal && this.state.userAddress}
          onHide={(event) => this.hideModal(event)}
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Verify Your Primary Address</Modal.Title>
            <IconButton onClick={(event)=> this.hideModal(event)}>
              <CloseIcon style={{color:"#fff"}} />
            </IconButton>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "450px",
              overflowY: "auto",
              textAlign: "justify",
              wordSpacing: "2px",
            }}
          >
            {this.state.loaderShow ? <Loader></Loader> : ""}

            <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
              <Grid item xs={12} md={12} lg={12}>
                <p style={customStyle.QuickQtTopRightText2}>
                  Your ID will be mailed to your mailing address. Please verify your address.
                </p>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1ZipPaymentModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    value={this.state.userAddress && this.state.userAddress.postalCode}
                    name={"Zip"}
                    label={"Zip Code"}
                    reqFlag={true}
                    disable={true}
                    style={customStyle.textFieldWrp}
                    length={5}
                    fieldType={"zip"}
                    errMsg={"Enter Valid Zip Code"}
                    helperMsg={"Zip Code Required"}
                    parentDetails={{ label: "Zip" }}
                  ></Sample>
                </div>
              </Grid>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1ZipPaymentModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    value={this.state.userAddress && this.state.userAddress.street}
                    name={"Street_suite"}
                    label={"Street,Suite"}
                    reqFlag={true}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={55}
                    fieldType={"street"}
                    errMsg={"Enter valid street"}
                    helperMsg={"Street required"}
                    parentDetails={{ label: "Street" }}
                  ></Sample>
                </div>
                {
                  this.state.isMailingStreet &&
                  (this.state.suggestions && this.state.suggestions[0]) ?
                  <div style={customStyle.suggestionDiv}>
                    <div style={customStyle.closeDropDiv}>
                      <text style={customStyle.closeDrop} onClick={() => this.setState({suggestions: {}, isMailStreetSelected: true })}>X</text>
                    </div>
                    <Suggestions
                      suggestions={this.state.suggestions}
                      selectSuggestion={(v) => this.selectSuggestion(v)}
                    />
                  </div>
                  :
                  this.state.isMailingStreet && this.state.userAddress.street && !this.state.isMailStreetSelected &&
                  <div style={customStyle.noEntriesDiv}>
                    <div style={customStyle.closeDropDiv}>
                      <text style={customStyle.closeDrop} onClick={() => this.setState({suggestions: {}, isMailStreetSelected: true })}>X</text>
                    </div>
                    <text>No entries available. Please fill the address manually.</text>
                  </div>
                }
              </Grid>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1ZipPaymentModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    value={this.state.userAddress.addrs}
                    name={"Street_address"}
                    label={"Street Address 2"}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={55}
                    fieldType={"street"}
                    errMsg={"Enter valid street"}
                    parentDetails={{ label: "address" }}
                  ></Sample>
                </div>
              </Grid>
            </Grid>

            <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1CityPayModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    value={this.state.userAddress && this.state.userAddress.city}
                    name={"City"}
                    label={"City"}
                    reqFlag={true}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={100}
                    fieldType={"city"}
                    errMsg={"Enter valid city"}
                    helperMsg={"City required"}
                    parentDetails={{ name: "city", label: "city" }}
                    makeValid={this.state.makeCityValid}
                  ></Sample>
                </div>
              </Grid>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1StatePayModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={"State"}
                    label={"State"}
                    value={this.state.userAddress && this.state.userAddress.state}
                    reqFlag={true}
                    disable={true}
                    style={customStyle.textFieldWrp}
                    length={2}
                    fieldType={"text"}
                    errMsg={"Enter valid state"}
                    helperMsg={"State required"}
                    parentDetails={{ name: "state", label: "state" }}
                    makeValid={this.state.makeStateValid}
                  ></Sample>
                </div>
              </Grid>
              <Grid item xs={6} md={4} lg={4}>
                <div style={customStyle.EnrollNew1CountryPayModal}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={"Country"}
                    label={"Country"}
                    value={this.state.userAddress && this.state.userAddress.country}
                    reqFlag={true}
                    disable={true}
                    style={customStyle.textFieldWrp}
                    length={2}
                    fieldType={"text"}
                    errMsg={"Enter valid country"}
                    helperMsg={"Country required"}
                    parentDetails={{ name: "country" }}
                  ></Sample>
                </div>
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isBillAddrDiff}
                      onChange={() => this.changeBillAddreDiff()}
                    />
                  }
                  label="Billing address is different than mailing address."
                />
              </Grid>
            </Grid>
            {this.state.isBillAddrDiff && (
              <>
                <h6 style={{ paddingTop: "10px" }}>Billing Address : </h6>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  xs={12}
                  md={12}
                  lg={12}
                >
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress.zip}
                        name={"Zip"}
                        label={"Zip Code"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={5}
                        fieldType={"zip"}
                        errMsg={"Enter Valid Zip Code"}
                        helperMsg={"Zip Code Required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Zip",
                        }}
                        makeValid={this.state.makeBZipValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress.street}
                        name={"Street_suite"}
                        label={"Street,Suite"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={55}
                        fieldType={"street"}
                        errMsg={"Enter valid street"}
                        helperMsg={"Street required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Street",
                        }}
                      ></Sample>
                    </div>
                    {
                      !this.state.isMailingStreet &&
                      (this.state.suggestions && this.state.suggestions[0]) ?
                      <div style={customStyle.suggestionDiv}>
                        <div style={customStyle.closeDropDiv}>
                          <text style={customStyle.closeDrop} onClick={() => this.setState({ suggestions: {}, isBillStreetSelected: true })}>X</text>
                        </div>
                        <Suggestions
                          suggestions={this.state.suggestions}
                          selectSuggestion={(v) => this.selectSuggestion(v)}
                        />
                      </div>
                      :
                      !this.state.isMailingStreet && this.state.userBillingAddress.street && !this.state.isBillStreetSelected &&
                      <div style={customStyle.noEntriesDiv}>
                        <div style={customStyle.closeDropDiv}>
                          <text style={customStyle.closeDrop} onClick={() => this.setState({ suggestions: {}, isBillStreetSelected: true })}>X</text>
                        </div>
                        <text>No entries available. Please fill the address manually.</text>
                      </div>
                    }
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress.addrs}
                        name={"Street_address"}
                        label={"Street Address 2"}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={55}
                        fieldType={"street"}
                        errMsg={"Enter valid street"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-Address",
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  spacing={1}
                  xs={12}
                  md={12}
                  lg={12}
                >
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CityPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress.city}
                        name={"City"}
                        label={"City"}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp}
                        length={100}
                        fieldType={"city"}
                        errMsg={"Enter valid city"}
                        helperMsg={"City required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-city",
                        }}
                        makeValid={this.state.makeBCityValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1StatePayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={"State"}
                        label={"State"}
                        value={this.state.userBillingAddress.state}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp}
                        length={2}
                        fieldType={"text"}
                        errMsg={"Enter valid state"}
                        helperMsg={"State required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-state",
                        }}
                        makeValid={this.state.makeBStateValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CountryPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={"Country"}
                        label={"Country"}
                        value={this.state.userBillingAddress.country}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp}
                        length={2}
                        fieldType={"text"}
                        errMsg={"Enter valid country"}
                        helperMsg={"Country required"}
                        parentDetails={{
                          flag: "BillAddr",
                          label: "BillAddr-country",
                        }}
                        makeValid={this.state.makeBCountryValid}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
              <CustomeButton
                disabled={this.state.isBillAddrValid}
                onClick={this.submitAddress}
                style={customStyle.m10}
              >
                Submit
              </CustomeButton>
            {/* <CustomeButton disabled={this.state.userAddress.street ? false : true} onClick={this.submitAddress} style={customStyle.m10}>
                            Submit
                        </CustomeButton> */}
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.submitWaitModal}
          centered
        >
          <Modal.Body>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <InfoIcon style={{ fill: '#f2b443', fontSize: 50, marginBottom: 30 }} />
              <p>Your enrollment application is being submitted. Do not close this browser window until you see a success message.</p>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          size="md"
          show={this.state.showPlaid}
          centered
          onHide={(event) => { }}
          backdrop="static"
        >
          <Modal.Header style={customStyle.plaid_modal_header}>
            <Modal.Title>Bank Account Verification</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{padding : 0}}>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                minHeight: "87vh",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <iframe
                ref={this.iframeRef}
                src={this.state.plaidLink}
                width={"100%"} height={"auto"}
              />
            </div>
          </Modal.Body>
        </Modal>
        
        <Modal
          size="md"
          show={this.state.isACHFailed}
          centered
          onHide={(event) => { }}
          backdrop="static"
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <text>Your bank account verification has failed. To try again, click on the verification link that was mailed to you. Alternatively, speak to the health representative to change your payment method.</text>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              onClick={() => window.close()}
              style={customStyle.m10}
            >
              OK
            </CustomeButton>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subId: state.subId,
    email: state.email,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(SubmitApplication));



const StatusPopup = (props) => {
  const [status, setStatus] = React.useState(null);
  const [flag, setFlag] = React.useState(false);
  const [id, setID] = React.useState(null);
  const [sourceid,  setsourceid] = React.useState(null);
  const [subID] = React.useState(JSON.parse(sessionStorage.getItem("STATE_PARAM")).subID);
  React.useEffect(()=>{
    getUserStatus();
    setInterval(getUserStatus, 4000);
  }, []);



  const getUserStatus = () =>{
    let subId = JSON.parse(localStorage.getItem("CurrentLoginUser")).id;
    axios.get(configuration.baseUrl + `/enrollment/getUserStatus/${subId}`)
    .then((response) => {
      setStatus(response.data.response);
      var flg = response.data.response.filter(x => x.flag === false || x.flag === null)
      if(flg[0]){
        setFlag(true)
      }else{
        setFlag(false);
        // axios.get(configuration.baseUrl+"/setupfamily/getMemberBySubID/"+subId).then((res) => { 
        //   axios.get(process.env.REACT_APP_AGENT_URL + `/enrollment/getViewDetails/${res.data.response.id}`).then(res =>{
        //     setID(res.data.response.memberId);
        //   })
        // })
      }
    })
  }

  const closeWindow = () =>{
      sessionStorage.removeItem("STATE_PARAM");
      sessionStorage.removeItem("STATE_VAL");
      sessionStorage.removeItem("CLIENT_ID");
      sessionStorage.removeItem("CHAT_BOX_Id");
      cookies.remove("STATE_PARAM", { path: "/" });
      window.top.postMessage(
        JSON.stringify({
          message: flag? "finalGoToDashboard" : 'GoToDashboard',
          subID: subID
        }),
        '*'
      );
      window.close();
  }
  const viewReceipt = () => {
    props.callReceiptModal()
  }
  return( <Modal
    size="lg"
    show={true && !props.reEnrollBySC}
    onHide={(event) =>{}
      // this.setState({ paymentScreenModal: false, loaderShow: false })
    }
    backdrop="static"
    centered
  >
    <Modal.Header style={customStyle.modal_header}>
      <Modal.Title>Enrollment Status</Modal.Title>
    </Modal.Header>
    <Modal.Body
      style={{
        margin: "10px",
        textAlign: "justify",
        fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        fontSize: "15px",
      }}
    >
      {status ? status.map((value, i)=>(
        <div style={{display: 'flex', flexDirection: "row", justifyContent: "space-between"}}>
          <div style={{display: 'flex', alignItems: 'center', width: 360}}>
          <p style={{fontFamily : 'Roboto, Arial, Helvetica, sans-serif', 
          // width: (i === status.length-2 && status[status.length-2].flag === false)? "100%":"100%",
          marginBottom: (i === 0 || i === status.length-3 || i === status.length-2)? 1: 13, 
          fontWeight: "bold", 
          color: (i === status.length -2 && (value.flag === false || value.flag == "Pending"))? "red": "#000"
          }}>
            {i === status.length -2 ?
             <img src={(value.flag === false || value.flag == "Pending")?failIcon: value.flag ? accessIcon : pendingIcon} width={"18px"} style={{marginRight: 10}}/> :
            <img src={value.flag?accessIcon: pendingIcon} width={"18px"} style={{marginRight: 10}}/>
            }
            {value.message}</p>
            </div>
           {i === 0 && <NextButton
           disabled={value.flag}
              style={{
                fontWeight:"bold",
                minWidth: "fit-content",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
                marginBottom: "10px"
              }}
              onClick={() => props.sendAuthResendAuth()}
            >
              RESEND AUTH
            </NextButton>}

           {i === status.length-1 || i === status.length-2 && 
           <div style={{display: 'flex', justifyContent: 'flex-end', visibility: "hidden"}}>
              <NextButton
                disabled={status[status.length-2].flag !== false || status[status.length-1].flag}
                style={{
                  marginRight: '10px',
                  marginLeft: '10px',
                  fontWeight:"bold",
                  minWidth: "fit-content",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  fontSize: "15px",
                  marginBottom: "10px"
                }}
                onClick={() => props.saveApplication(true)}
              >
                RETRY LATER
              </NextButton>
              <NextButton
                disabled={status[status.length-2].flag !== "Pending" && (status[status.length-2].flag !== false || status[status.length-1].flag)}
                style={{
                  fontWeight:"bold",
                  minWidth: "fit-content",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  fontSize: "15px",
                  marginBottom: "10px"
                }}
                onClick={() => props.updatePaymentInfo()}
              >
               UPDATE PAYMENT INFO
              </NextButton>
            </div>
           }
              {i === status.length-1 && value.memberId &&
              <p style={{fontFamily : 'Roboto, Arial, Helvetica, sans-serif', margin: 9}}>Member ID: <span style={{fontWeight: "bold",}}>{value.memberId}</span></p>
            }
             

        </div>
      )): <center>
      <CircularProgress />
      </center> }
    
      
    </Modal.Body>
    <Modal.Footer>

    {status &&
    <NextButton
    style={{
      marginRight: "10px",
      fontWeight:"bold",
      minWidth: "fit-content",
      fontFamily: "Roboto, Arial, Helvetica, sans-serif",
      fontSize: "15px",
      marginBottom: "10px"
    }}
    onClick={() => viewReceipt()}
    disabled={status && (status[status.length-2].flag == "Pending" || !status[status.length-2].flag)}
  >
    VIEW RECEIPT
  </NextButton>
  }
  
      <NextButton
        style={{
          marginRight: "14px",
          fontWeight:"bold",
          minWidth: "fit-content",
          fontFamily: "Roboto, Arial, Helvetica, sans-serif",
          fontSize: "15px",
          marginBottom: "10px"
        }}
        onClick={() => closeWindow()}
      >
        GO TO DASHBOARD
      </NextButton>

    </Modal.Footer>
  </Modal>)
}

function AlertModal(props) {
  return (
    <Modal style={{ zIndex: 1500 }} size="md" show={props.showAlert} onHide={(event) => props.toggleAlert(null)} centered backdrop='static'>
      <Modal.Header style={customStyle.modal_header}>
        <Modal.Title style={{ color: 'white' }} className="h6">Message</Modal.Title>
        <IconButton style={{
          float: 'right',
          width: '25px',
          height: '25px',
          color: 'white'
          // marginTop: '5px'
        }} onClick={(event) =>
          props.toggleAlert()
        }>
          <CloseIcon />
        </IconButton>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '200px' }}>
        <div style={{ height: 'auto', overflowX: 'hidden', overflowY: 'auto', fontSize: "18px", color: '#000' }}>
          <p>{props.alertMsg}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NextButton
          style={{
            marginRight: "14px",
            fontWeight: "bold",
            minWidth: "fit-content",
            fontFamily: "Roboto, Arial, Helvetica, sans-serif",
            fontSize: "15px",
            marginBottom: "10px"
          }}
          onClick={() => props.toggleAlert()}
        >
          Ok
        </NextButton>
      </Modal.Footer>
    </Modal>
  )
}